import React, { useEffect, useRef, useState, useCallback } from "react";
import { Conversation } from "@11labs/client";
import { useParams } from "react-router-dom";
import AFRAME from "aframe";

import { Entity } from "aframe-react";
//import info from "../assets/info.png";
import info from "../assets/message.png";
import dollar_icon from "../assets/dollar_icon.svg";
import flecha_derecha from "../assets/arrow-right.png";
import flecha_izquierda from "../assets/arrow-left.png";
import gafas_white from "../assets/icono-go.png";
import video from "../assets/video.png";
import image from "../assets/image-icon.png";
import folleto from "../assets/folleto.png";
import cursor_icon from "../assets/cursor.png";
//import textura_madera from "../assets/textura-madera.jpg";
import video1 from "../assets/videos/video-lemon.mp4";
import playv from "../assets/play.png";
import close from "../assets/close.png";

//import gafasVR from "../assets/vr_icon.svg";
import "./controles.css";
import LoadingSpin from "./loadingSpin";
import PopUpMsg from "./popUpMsg";
import OpenProject from "./openProject";
import EscenasMenu from "./escenasMenu";
import { Alert, Button } from "antd";
import "animate.css";
import MenuComponent from "./MenuComponent";
import ReactGA from "react-ga4";
import MenuOtras from "./MenuOtras";
//import Visitas from "./Visitas";
import { VisitasComponent } from "./export";
import MenuRedes from "./MenuRedes";
import MenuEscenas from "./MenuEscenas";
import MenuEnlaces from "./MenuEnlaces";
//import CardCar from "./CardCar";
import { ANALYTICS_EVENT_TYPE } from "../core/constants/analitics-constants";
import apiService from "../services/apiServices";
//import Otra360VR from "./player-components/Otra360VR";
//import exitPng from "../assets/exit.png";
import { Helmet } from "react-helmet";

//recursos para portal
import portal from "../assets/portal/portal.png";

import Otra360VR from "./player-components/Otra360VR";
import { ModalShare } from "./share-components/modalShare";
//import ModalConfirmationVR from "../core/componentsVR/ModalConfirmationVR";
//import { type } from "@testing-library/user-event/dist/types/utility";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import navigationAction from "./automatic-tour/navigationAction";
import { metricasService } from "../services/metricasService";
import { useUserAnonId } from "../hooks/useUserAnonId";
import { BannerAnimated } from "./player-components/banner-animated";
import { generateWhatsAppScript } from "./player-components/whatsappScript";
import PopUpEncuesta from "./player-components/PopUpEncuesta.jsx";
import ElevenLabsButton from "./player-components/ElevenLabsButton.jsx";
import AsistenteInmersial from "./asistente/AsistenteInmersial";
import ElevenLabsVR from "./player-components/ElevenLabsVR.jsx";
import phoneIcon from "../assets/phone-circ-icon.png";
import { formatTextWithLineBreaks } from "../helpers/processText";
import { IcHerramientas, IcVR } from "./player-components/IconosPlayer";

// import navigationAction from "./automatic-tour/navigationAction";

const THREE = AFRAME.THREE;

const driverObj = driver({
  showProgress: true,
  steps: [
    {
      popover: {
        title: "Guia Inicial",
        description: `Bienvenido a la experiencia 360.Esta guía te ayudará a navegar por la experiencia y a aprovechar al máximo tus sentidos`,
        side: "left",
        align: "start",
      },
    },
    {
      element: ".first-step",
      popover: {
        title: "Título de la Experiencia 360",
        description: "",
      },
    },
    {
      element: ".second-step",
      popover: {
        title: "Botón al canal de compras",
        description:
          "Descubre los productos que aparecen en la experiencia 360 y cómpralos directamente desde aquí.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: ".third-step",
      popover: {
        title: "Botón al ambiente VR",
        description:
          "Sumérgete en la experiencia 360 en realidad virtual para una experiencia aún más inmersiva.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: ".fourth-step",
      popover: {
        title: "Botón compartir en redes sociales",
        description:
          "Comparte la experiencia 360 con tus amigos y familiares en las redes sociales.",
        side: "left",
        align: "start",
      },
    },
    {
      element: ".fifth-step",
      popover: {
        title: "Botón de experiencias relacionadas",
        description:
          "Explora otras experiencias 360 similares y descubre nuevos mundos.",
        side: "top",
        align: "start",
      },
    },
    {
      element: ".sixth-step",
      popover: {
        title: "Menú de las escenas de la experiencia 360",
        description:
          "Navega por las diferentes escenas de la experiencia 360 y explora cada rincón.",
        side: "right",
        align: "start",
      },
    },
    {
      element: ".seventh-step",
      popover: {
        title: "Menú de herramientas",
        description:
          "Utiliza las herramientas de zoom, ampliar y vista VR para personalizar tu experiencia.",
        side: "right",
        align: "start",
      },
    },
  ],
  nextBtnText: "Siguiente",
  prevBtnText: "Anterior",
  doneBtnText: "Entendido",
});

require("aframe-look-at-component");

export default function Player360() {
  const [open, setOpen] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [popUpTitulo, setPopUpTitulo] = useState("");
  const [popUpContenido, setPopUpContenido] = useState(null);
  const [isMobileXp] = useState(AFRAME.utils.device.isMobile());
  const [isVR, setIsVR] = useState(false);

  //state que maneja el disparo de tour automático
  const [automaticTour, setAutomaticTour] = useState(false);

  //state que maneja el verdadero modo VR
  const [isVRMode, setIsVRMode] = useState(false);

  //posicion x para los portales
  const positionX = 0;

  //useState para el titulo del index.html
  const [tituloHtml, setTituloHtml] = useState("Griftin");

  //state que se enlaza con el mostrar el menu de escenas
  const [showCarrousel, setShowCarrousel] = useState(false);
  //mientras el visitante charla con el asistente, la barra del asistente ocupa el borde de abajo
  const [asistenteEnCharla, setAsistenteEnCharla] = useState(false);
  useEffect(() => {
    const alIniciar = (e) =>
      setAsistenteEnCharla(!(e.detail && e.detail.modo === "silencio"));
    const alTerminar = () => setAsistenteEnCharla(false);
    document.addEventListener("sesion-inicia", alIniciar);
    document.addEventListener("sesion-termina", alTerminar);
    return () => {
      document.removeEventListener("sesion-inicia", alIniciar);
      document.removeEventListener("sesion-termina", alTerminar);
    };
  }, []);

  //hook que maneja el id unico de usuario anonimo utilizado para metricas
  const { userAnonId, typeAccess } = useUserAnonId();

  const [escenaIndex, setEscenaIndex] = useState(null); // Inicializar como null para evitar flash
  const [proyecto, setProyecto] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [mobileVideoSrc, setMobileVideoSrc] = useState("");
  const [mobilePlayerPos, setMobilePlayerPos] = useState({ x: 0, y: 0, z: 1 });
  const [VRPopUpImage, setVRPopUpImage] = useState(null);
  const [timeOutClick, setTimeOutClick] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [animateEnabled, setAnimateEnabled] = useState(true);
  const [urlLink, setUrlLink] = useState("");
  const [showAlertLink, setShowAlertLink] = useState(false);
  const [showMenuFloat, setShowMenuFloat] = useState(true);
  const [desplegarMenu, setDesplegarMenu] = useState(false);
  //state que maneja el ocultamiento de la card de menu de otras segun click en pantalla
  const [desplegarCard, setDesplegarCard] = useState(false);
  const menuEnlacesOtrasRef = useRef(null);

  //state que maneja el sonido establecido
  const [soundSelected, setSoundSelected] = useState(proyecto?.sound || -13);
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);

  //boolean que maneja el modo de origen de los datos de la Experiencia
  //true: drive, false: API
  const [modo, setModo] = useState(true);

  //variables para analitica de permanencia
  const [spentTime, setSpentTime] = useState(0);
  const [startTime, setStartTime] = useState(null);

  //state que maneja la cantidad de visitas de una pagina
  const [countVisits, setCountVisits] = useState(0);

  //state que maneja la visibilidad del video en vr
  const [showVideoVR, setShowVideoVR] = useState(false);

  //state que captura las interacciones que luego seran enviadas a la API
  const [interactions, setInteractions] = useState({
    share_button: 0,
    cart_button: 0,
    scene_navigation_button: 0,
    experience_navigation_button: 0,
    video_button: 0,
    info_button: 0,
    image_button: 0,
    zoom_plus_button: 0,
    zoom_minus_button: 0,
    fullscreen_button: 0,
    carrousel_scenes_button: 0,
  });

  //state que maneja la visibilidad del modalVR de confirmacion
  const [showModalVR, setShowModalVR] = useState(false);

  const [titulo360Value, setTitulo360Value] = useState(" ");
  const [alertErrorMessage, setAlertErrorMessage] = useState({
    titulo: "",
    mensaje: "",
  });

  const [redesState, setRedesState] = useState({
    facebook: "",
    twitter: "",
    youtube: "",
  });

  const [linksDataState, setLinksData] = useState([]);

  const location = useParams();
  const cielo = useRef(null);
  const escena = useRef(null);
  const camara = useRef(null);
  const cursor = useRef(null);
  const vrbutton = useRef(null);
  const videoControl = useRef(null);
  const iframe = useRef(null);
  var distanciaTouch = 0;
  var touchPos = { x: 0, y: 0 };

  //  const ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;

  //state que controla que el post de pagina visitada se ejecute una vez
  const [pageVisited, setPageVisited] = useState(false);

  //manejemos la carga total de la aplicacion en este estado, es para hacer algo luego de haberse cargado todo
  const [isAllLoaded, setIsAllLoaded] = useState(false);

  const getTipo = (e) => {
    switch (e.tipo) {
      case 0:
        return "video-button";
      case 1:
        return "msg-button";
      case 2:
        return "view-button";
      case 3:
        return "image-button";
      default:
        return null;
    }
  };

  //registro de evento de navegacion a url externa : Fernando
  if (!AFRAME.components["navigate-out"]) {
    AFRAME.registerComponent("navigate-out", {
      schema: { type: "string" }, // URL de destino

      init: function () {
        const url = this.data;
        this.el.addEventListener("click", () => {
          //console.log("Navegando a la URL:", url);
          window.location.href = url;
        });
      },
    });
  }

  // Mantiene un panel siempre alcanzable por el cursor fuse en modo VR:
  // sigue el YAW (giro horizontal) de la cámara e ignora el pitch a propósito,
  // así el panel no "se escapa" cuando el usuario mira hacia abajo para gatillar el fuse.
  if (!AFRAME.components["hud-follow"]) {
    AFRAME.registerComponent("hud-follow", {
      schema: {
        distance: { type: "number", default: 2.5 },
        height: { type: "number", default: -1.1 },
        tilt: { type: "number", default: 25 },
      },
      tick: function () {
        const camera = this.el.sceneEl.camera;
        if (!camera) return;

        const yaw = this.el.sceneEl.camera.getWorldQuaternion(new THREE.Quaternion());
        const euler = new THREE.Euler().setFromQuaternion(yaw, "YXZ");

        const { distance, height, tilt } = this.data;
        this.el.setAttribute(
          "position",
          `${Math.sin(euler.y) * -distance} ${height} ${Math.cos(euler.y) * -distance}`
        );
        this.el.setAttribute("rotation", `${tilt} ${THREE.MathUtils.radToDeg(euler.y)} 0`);
      },
    });
  }

  // if (!AFRAME.components["exit-inmersion-VR"]) {
  //   AFRAME.registerComponent("exit-inmersion-VR", {
  //     schema: { type: "string" },
  //     init: function () {
  //       const dato = this.data;
  //       this.el.addEventListener("click", () => {
  //         console.log("Saliendo de la inmersion", dato);
  //         //window.location.href = "/";
  //         //  escena.current.exitVR();
  //         setFullscreen();
  //       });
  //     },
  //   });
  // }

  // useEffect(() => {
  //   console.log("%c PASANDO POR EFFECT DE SOUND SELECTED","color: yellow" ,soundSelected);
  // }, [soundSelected]);

  useEffect(() => {}, [userAnonId]);

  useEffect(() => {
    const videoAsset = document.querySelector("#video-1");

    if (videoAsset) {
      if (showVideoVR && isVRMode) {
        videoAsset.muted = false; // Activar sonido
        videoAsset.volume = 1.0;
        videoAsset.play().catch(console.error);
        setPlaying(true);
      } else {
        videoAsset.pause();
        setPlaying(false);
      }
    }
  }, [showVideoVR, isVRMode]);

  // ElevenLabs: sesión manejada por @11labs/client (sin web component)
  const elevenLabsConversationRef = useRef(null);
  const [elevenLabsAgentId, setElevenLabsAgentId] = useState(null);
  const [elevenLabsStatus, setElevenLabsStatus] = useState("idle"); // idle | connecting | connected
  // cooldown para el toggle desde el panel VR: el cursor fuse re-dispara "click"
  // cada vez que el rayo re-entra al objeto, sin esto abre/cierra la sesión en loop.
  const lastElevenLabsToggleRef = useRef(0);

  useEffect(() => {
    // al desmontar el player (navegación fuera de /player), no dejar la
    // sesión ni el micrófono abiertos.
    return () => {
      elevenLabsConversationRef.current?.endSession();
    };
  }, []);

  useEffect(() => {
    if (!proyecto?.scripts) return;
    const script = proyecto.scripts.find(
      (s) => s.tipo === "elevenlabs" && s.habilitado
    );
    if (script) {
      const html = script.texto || script.html || "";
      const match = html.match(/agent-id="([^"]+)"/);
      if (match?.[1]) setElevenLabsAgentId(match[1]);
    } else {
      setElevenLabsAgentId(null);
    }
  }, [proyecto]);


  useEffect(() => {
    //agreguemos a la escena el evento necesario para que sepa cuando esta en modo VR o no
    const sceneEl = document.querySelector("a-scene");

    const enterModeVR = () => {
      setIsVRMode(true);
    };

    const exitModeVR = () => {
      setIsVRMode(false);
    };

    sceneEl.addEventListener("enter-vr", enterModeVR);
    sceneEl.addEventListener("exit-vr", exitModeVR);

    //tooltip para gafas y VR
    if (cielo.current && !AFRAME.components["custom-tooltip"]) {
      //script para play de video en vr
      //   AFRAME.registerComponent('play-pause', {
      // 	init: function () {
      // 		var myVideo = document.querySelector('#video-1');
      // 		var videoControls = document.querySelector('#videoControls');
      // 		this.el.addEventListener('click', function () {
      // 			if (myVideo.paused) {
      // 				myVideo.play();
      // 				videoControls.setAttribute('src', '#pause');
      // 			} else {
      // 				myVideo.pause();
      // 				videoControls.setAttribute('src', '#play');
      // 			}
      // 		});
      // 	}
      // });

      // Primero registrar el componente personalizado
      AFRAME.registerComponent("custom-tooltip", {
        schema: {
          value: { type: "string", default: "" },
          color: { type: "string", default: "white" },
          backgroundColor: { type: "string", default: "#000000" },
          backgroundOpacity: { type: "number", default: 0.5 },
          padding: { type: "number", default: 0.2 },
          scale: { type: "vec3", default: { x: 8, y: 8, z: 8 } },
        },

        init: function () {
          // Crear el plano de fondo
          this.background = document.createElement("a-plane");
          this.el.appendChild(this.background);

          // Crear el texto
          this.text = document.createElement("a-text");
          this.text.setAttribute("align", "center");
          this.text.setAttribute("position", "0 0 0.01");
          this.el.appendChild(this.text);

          this.updateLayout();
        },

        updateLayout: function () {
          // Configurar el texto
          this.text.setAttribute("text", {
            value: this.data.value,
            color: this.data.color,
            align: "center",
            shader: "msdf",
            font: "/fonts/custom-font-msdf/customFontAframe-msdf.json",
            fontImage: "/fonts/custom-font-msdf/customFontAframe.png",
            negate: false,
            baseline: "top",
          });

          // Esperar a que el texto se cargue para obtener sus dimensiones
          this.text.addEventListener("loaded", () => {
            const textWidth = this.text.components.text.data.width;
            const textHeight = this.text.components.text.data.height;

            // Ajustar el tamaño del plano de fondo
            this.background.setAttribute(
              "width",
              textWidth + this.data.padding * 1
            );
            this.background.setAttribute(
              "height",
              textHeight + this.data.padding * 3
            );
            this.background.setAttribute("material", {
              color: this.data.backgroundColor,
              opacity: this.data.backgroundOpacity,
              transparent: true,
            });
          });
        },

        update: function () {
          this.updateLayout();
        },
      });
    }

    //const interval = setInterval(() => {
    //if (proyecto?.escenas && cielo.current && !AFRAME.components["cursor-listener"]) {
    if (cielo.current && !AFRAME.components["to-scene-1"]) {
      AFRAME.registerComponent("to-scene-1", {
        init: function () {
          //let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(0);
            }
          });
        },
      });
    }
    if (cielo.current && !AFRAME.components["to-scene-2"]) {
      AFRAME.registerComponent("to-scene-2", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 2: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(1);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-3"]) {
      AFRAME.registerComponent("to-scene-3", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 3: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(2);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-4"]) {
      AFRAME.registerComponent("to-scene-4", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 4: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(3);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-5"]) {
      //console.log("PROYECTO ADENTRO DEL REGISTRO DE EVENTO 5!!!!", proyecto);

      AFRAME.registerComponent("to-scene-5", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 5: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(4);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-6"]) {
      AFRAME.registerComponent("to-scene-6", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 5: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(5);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-7"]) {
      AFRAME.registerComponent("to-scene-7", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 5: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              //setEscenaOnEventVR(indiceEscena);
              setEscenaOnEventVR(6);
            }
          });
        },
      });
    }

    if (cielo.current && !AFRAME.components["to-scene-8"]) {
      AFRAME.registerComponent("to-scene-8", {
        init: function () {
          let lastIndex = -1;
          // const COLORS = ["red", "green", "blue"];

          this.el.addEventListener("click", function (evt) {
            // lastIndex = (lastIndex + 1) % COLORS.length;
            // this.setAttribute("material", "color", COLORS[lastIndex]);
            // console.log("I was clicked at 5: ", evt.detail.intersection.point);

            if (cielo.current) {
              //cielo.current.setAttribute("material", "color", COLORS[lastIndex]);
              // cielo.current.setAttribute("material", "src", "https://images.pexels.com/photos/17325269/pexels-photo-17325269/free-photo-of-molinos-de-viento.jpeg?auto=compress&cs=tinysrgb&w=600");
              //cielo.current.setAttribute("material", "src", skySrc); // Usa el valor actual del ref
              if (playing) return;
              //cielo.current.emit("fadein");
              setEscenaOnEventVR(7);
            }
          });
        },
      });
    }
    //}, 100); // Revisa cada 100 ms hasta que las condiciones se cumplan.

    // Limpia el intervalo si el componente se desmonta antes de cumplir las condiciones.
    //  return () => clearInterval(interval);
    // Limpia los event listeners cuando el componente se desmonta
    return () => {
      sceneEl.removeEventListener("enter-vr", enterModeVR);
      sceneEl.removeEventListener("exit-vr", exitModeVR);
    };
  }, []);

  // useEffect(() => {
  //   if (proyecto) {
  //     for (let i = 0; i < proyecto.escenas.length; i++) {
  //       const element = document.getElementById(`link${i + 1}`);
  //       if (element) {
  //         element.setAttribute("visible", "true"); // Cambia el atributo "visible" a true en A-Frame
  //         const label = document.getElementById(`label${i + 1}`);
  //         if (label) {
  //           label.setAttribute("value", proyecto.escenas[i].titulo); // Cambia el atributo "visible" a true en A-Frame
  //         }
  //       } else {
  //         console.warn(`Elemento con ID link${i + 1} no encontrado.`);
  //       }
  //     }
  //   }
  // }, [proyecto]);

  const setEscenaOnEventVR = (indice) => {
    if (!isVRMode) return;
    cielo.current.emit("fadein");
    console.log(
      "%c ESTA PASANDO POR SETESCENA ON EVENT VR",
      "color: teal",
      indice
    );
    setInteractions((prevInteractions) => ({
      ...prevInteractions,
      scene_navigation_button: prevInteractions.scene_navigation_button + 1,
    }));

    let controls = camara.current.components["look-controls"];
    setEscenaIndex(indice);
  };

  // const setEscena = (escenaTitulo, p) => {
  //     console.log("<<<<<<<ADENTRO DE ESCENA TITULO",escenaTitulo);
  //     console.log("PROYECTO ADENTRO DE SET ESCENA",p)
  //     cielo.current.emit("fadeout");
  //     let controls = camara.current.components["look-controls"];
  //     console.log("CONTROLS", controls);
  //     setTimeout(() => {
  //       if (controls) {
  //         let indice = p.escenas.findIndex((x) => x.titulo === escenaTitulo);
  //         console.log("###################INDICE", indice);
  //         if (indice < 0) indice = 0;
  //         setEscenaIndex(indice);
  //         let valorX =
  //           ((p.escenas[indice].inicio ? p.escenas[indice].inicio.x : 0) *
  //             Math.PI) /
  //           180;
  //         let valorY =
  //           (((p.escenas[indice].inicio ? p.escenas[indice].inicio.y : 0) *
  //             Math.PI) /
  //             180) *
  //           -1;
  //         controls.pitchObject.rotation.x = valorX;
  //         controls.yawObject.rotation.y = valorY;
  //       }
  //       cielo.current.emit("fadein");
  //     }, 500);
  //   };

  // const setEscena = (escenaTitulo, p) => {
  //   cielo.current.emit("fadeout");

  //   // Usar un intervalo para verificar cuándo controls está disponible
  //   const intervalId = setInterval(() => {
  //     let controls = camara.current.components["look-controls"];
  //     console.log("CONTROLS", controls);

  //     if (controls) {
  //       clearInterval(intervalId); // Detenemos el intervalo cuando controls esté disponible
  //       let indice = p.escenas.findIndex((x) => x.titulo === escenaTitulo);

  //       if (indice < 0) indice = 0;

  //       setEscenaIndex(indice);

  //       let valorX =
  //         ((p.escenas[indice].inicio ? p.escenas[indice].inicio.x : 0) *
  //           Math.PI) /
  //         180;
  //       let valorY =
  //         (((p.escenas[indice].inicio ? p.escenas[indice].inicio.y : 0) *
  //           Math.PI) /
  //           180) *
  //         -1;

  //       controls.pitchObject.rotation.x = valorX;
  //       controls.yawObject.rotation.y = valorY;

  //       // Sync cameraWrapper rotation with camera
  //       // const cameraWrapper = document.getElementById('cameraWrapper');
  //       // if (cameraWrapper) {
  //       //   cameraWrapper.object3D.rotation.y = valorY;
  //       //   cameraWrapper.object3D.rotation.x = valorX;
  //       // }

  //       cielo.current.emit("fadein");
  //     }
  //   }, 100); // Verifica cada 100ms si los controles están disponibles
  // };

  const setEscena = (escenaTitulo, p) => {
    cielo.current.emit("fadeout");

    const intervalId = setInterval(() => {
      let controls = camara.current.components["look-controls"];

      if (controls) {
        clearInterval(intervalId);
        let indice = p.escenas.findIndex((x) => x.titulo === escenaTitulo);

        if (indice < 0) indice = 0;

        // PRIMERO: Precargar la imagen
        const nuevaImagen = new Image();
        nuevaImagen.onload = () => {
          // SOLO después de cargar la imagen:
          setEscenaIndex(indice);

          let valorX =
            ((p.escenas[indice].inicio ? p.escenas[indice].inicio.x : 0) *
              Math.PI) /
            180;
          let valorY =
            (((p.escenas[indice].inicio ? p.escenas[indice].inicio.y : 0) *
              Math.PI) /
              180) *
            -1;

          controls.pitchObject.rotation.x = valorX;
          controls.yawObject.rotation.y = valorY;

          // Esperar un frame para que React actualice
          setTimeout(() => {
            cielo.current.emit("fadein");
          }, 100);
        };

        nuevaImagen.onerror = () => {
          // Si falla la carga, mostrar error
          console.error(
            `Error cargando imagen de escena: ${p.escenas[indice].fondo}`
          );
          cielo.current.emit("fadein"); // Hacer fadein de la escena anterior
        };

        // Iniciar carga de la imagen
        nuevaImagen.src = p.escenas[indice].fondo;
      }
    }, 100);
  };

  const handleElevenLabsToggle = useCallback(async () => {
    // evita el loop conectar/colgar cuando el cursor fuse re-dispara "click"
    // porque el usuario se quedó mirando fijo el panel.
    const now = Date.now();
    if (now - lastElevenLabsToggleRef.current < 1500) return;
    lastElevenLabsToggleRef.current = now;

    if (elevenLabsStatus === "connecting") return;

    if (elevenLabsConversationRef.current) {
      await elevenLabsConversationRef.current.endSession();
      elevenLabsConversationRef.current = null;
      setElevenLabsStatus("idle");
      return;
    }
    if (!elevenLabsAgentId) return;
    setElevenLabsStatus("connecting");
    try {
      const escenasDisponibles = proyecto?.escenas
        ?.map((e) => e.titulo)
        .filter(Boolean)
        .join(", ") || "";

      const conversation = await Conversation.startSession({
        agentId: elevenLabsAgentId,
        dynamicVariables: {
          escenas_disponibles: escenasDisponibles,
        },
        clientTools: {
          toggle_musica: async () => {
            console.log("%c ElevenLabs tool: toggle_musica", "color: cyan");
            setIsSoundPlaying((prev) => {
              const newState = !prev;
              setTimeout(() => {
                const soundEntity = document.getElementById("sound-entity");
                if (!soundEntity) return;
                try {
                  if (newState) {
                    if (soundEntity.components && soundEntity.components.sound) {
                      soundEntity.components.sound.playSound();
                    }
                  } else {
                    if (soundEntity.components && soundEntity.components.sound) {
                      soundEntity.components.sound.pauseSound();
                    }
                  }
                } catch (error) {
                  console.error("Error handling sound:", error);
                }
              }, 1000);
              return newState;
            });
            return "ok";
          },
          navegar_escena: async ({ nombre }) => {
            console.log("%c ElevenLabs tool: navegar_escena", "color: cyan", nombre);
            if (!proyecto) return "error: no hay proyecto cargado";
            setTimeout(() => {
              try {
                setEscena(nombre, proyecto);
              } catch (error) {
                console.error("Error navegando escena:", error);
              }
            }, 0);
            return "ok";
          },
        },
        onConnect: () => setElevenLabsStatus("connected"),
        onDisconnect: () => {
          elevenLabsConversationRef.current = null;
          setElevenLabsStatus("idle");
        },
        onError: (msg) => {
          console.error("ElevenLabs error:", msg);
          setElevenLabsStatus("idle");
        },
      });
      elevenLabsConversationRef.current = conversation;
    } catch (err) {
      console.error("ElevenLabs: error iniciando sesión", err);
      setElevenLabsStatus("idle");
    }
  }, [elevenLabsAgentId, elevenLabsStatus, setIsSoundPlaying, proyecto, setEscena]);

  const setVR = () => {
    escena.current.enterVR();
  };

  const setFullscreen = () => {
    if (!document.fullscreenElement)
      document.documentElement.requestFullscreen();
    else document.exitFullscreen();
  };

  const zoomIn = (zoomin) => {
    let objCamara = camara.current.getAttribute("camera", "zoom");
    objCamara.zoom += 0.1 * (zoomin ? 1 : -1);
    if (objCamara.zoom <= 1) objCamara.zoom = 1;
    if (objCamara.zoom >= 5) objCamara.zoom = 5;

    camara.current.setAttribute("camera", "zoom", objCamara.zoom);
  };

  const handleCardRelacionadas = (event) => {
    // console.log(event.target)
    // console.log("REFFFFFF", menuEnlacesOtrasRef.current)
    // console.log("contain event", !menuEnlacesOtrasRef.current.contains(event.target))
    if (
      menuEnlacesOtrasRef.current &&
      !menuEnlacesOtrasRef.current.contains(event.target)
    ) {
      // console.log("CLICKEANDO AFUERA!!");
      // console.log(desplegarCard);
      setDesplegarCard((prev) => false);
    } else {
      // console.log("CLICKEANDO ADENTRO!!");
      setDesplegarCard((prev) => true);
    }
  };

  //metodo que dispara el carrito
  const handleClickLinkButton = async (e) => {
    if (urlLink !== undefined && urlLink !== "") {
      ReactGA.event({
        category: "User",
        action: "onLinkClick",
      });
      //lugar adonde voy a disparar la carga de evento carrito para analiticas
      try {
        const data = {
          id: proyecto.id,
          userId: proyecto.userId,
          additional: {
            link: urlLink,
            userAnonId,
          },
        };
        if (!modo) {
          await apiService.trackEvent({
            type: ANALYTICS_EVENT_TYPE.CART_VISIT,
            experienceData: data,
          });
          //alimento el objeto de interacciones
          setInteractions((prevInteractions) => ({
            ...prevInteractions,
            cart_button: prevInteractions.cart_button + 1,
          }));
        }
      } catch (error) {
        console.error(error.message);
      }

      window.open(urlLink, "_blank");
    } else {
      setAlertErrorMessage({
        titulo: "Link Inexistente",
        mensaje:
          "Configure el enlace de la Experiencia 360 con su sitio web o su carrito de compras.",
      });
      setShowAlertLink(true);
      setTimeout(() => {
        setShowAlertLink(false);
      }, 2000);
    }
  };

  const [showModalShare, setShowModalShare] = useState(false);

  const handleShareButton = async () => {
    try {
      const data = {
        id: proyecto.id,
        userId: proyecto.userId,
        additional: {
          link: window.location.href,
          escena: proyecto.escenas[escenaIndex].titulo,
          userAnonId,
        },
      };
      if (!modo) {
        await apiService.trackEvent({
          type: ANALYTICS_EVENT_TYPE.SHARE_EXPERIENCE,
          experienceData: data,
        });
        //alimento el objeto de interacciones
        setInteractions((prevInteractions) => ({
          ...prevInteractions,
          share_button: prevInteractions.share_button + 1,
        }));
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setShowModalShare(true);
    }
  };

  const handleNavigateRelated = (urlTarget) => {
    if (urlTarget !== undefined && urlTarget !== "") {
      ReactGA.event({
        category: "User",
        action: "onLinkClick",
      });
      window.open(urlTarget, "_blank");
    } else {
      setAlertErrorMessage({
        titulo: "Link Inexistente",
        mensaje:
          "Configure el enlace de la Experiencia 360 con su sitio web o su carrito de compras.",
      });
      setShowAlertLink(true);
      setTimeout(() => {
        setShowAlertLink(false);
      }, 2000);
    }
  };

  const handleClickPlusButton = (e) => {
    zoomIn(true);
    //capturemos la metrica
    setInteractions((prevInteractions) => ({
      ...prevInteractions,
      zoom_plus_button: prevInteractions.zoom_plus_button + 1,
    }));
  };

  const handleClickMinusButton = (e) => {
    zoomIn(false);
    //capturemos la metrica
    setInteractions((prevInteractions) => ({
      ...prevInteractions,
      zoom_minus_button: prevInteractions.zoom_minus_button + 1,
    }));
  };

  const handleClickFullScreenButton = (e) => {
    setFullscreen();
    //capturemos la metrica
    setInteractions((prevInteractions) => ({
      ...prevInteractions,
      fullscreen_button: prevInteractions.fullscreen_button + 1,
    }));
  };

  //metodo que dispara el menu de escenas
  const handleClickScenesButton = (e) => {
    if (showCarrousel) {
      hiddenScenasShortcut();
      return;
    }
    viewScenasShortcut();
    //capturemos la metrica
    setInteractions((prevInteractions) => ({
      ...prevInteractions,
      carrousel_scenes_button: prevInteractions.carrousel_scenes_button + 1,
    }));
  };

  const handleClickOptionButton = (key_word) => {
    switch (key_word) {
      case "enlace_1_key":
        break;

      case "animation_key":
        setAnimateEnabled(!animateEnabled);
        break;
      case "twitter_key":
        if (redesState?.twitter !== undefined && redesState?.twitter !== "") {
          window.open(redesState.twitter, "_blank");
        } else {
          setAlertErrorMessage({
            titulo: "Twitter Inexistente",
            mensaje: "Configure el enlace a su plataforma de Twitter.",
          });
          setShowAlertLink(true);
          setTimeout(() => {
            setShowAlertLink(false);
          }, 2000);
        }
        break;
      case "youtube_key":
        if (redesState?.youtube !== undefined && redesState?.youtube !== "") {
          window.open(redesState.youtube, "_blank");
        } else {
          setAlertErrorMessage({
            titulo: "Youtube Inexistente",
            mensaje: "Configure el enlace a su plataforma de Youtube.",
          });
          setShowAlertLink(true);
          setTimeout(() => {
            setShowAlertLink(false);
          }, 2000);
        }
        break;
      case "facebook_key":
        if (redesState?.facebook !== undefined && redesState?.facebook !== "") {
          window.open(redesState.facebook, "_blank");
        } else {
          setAlertErrorMessage({
            titulo: "Facebook Inexistente",
            mensaje: "Configure el enlace a su plataforma de Facebook.",
          });
          setShowAlertLink(true);
          setTimeout(() => {
            setShowAlertLink(false);
          }, 2000);
        }
        break;

      default:
        break;
    }
  };

  const setVRPopUpPosition = (e, elemento = "player") => {
    let pos = camara.current.getAttribute("position");
    let rot = camara.current.getAttribute("rotation");
    //console.log(pos, rot);

    const distance = 30;
    const theta = (rot.y * Math.PI) / 180;
    const planeX = pos.x - distance * Math.sin(theta);
    const planeZ = pos.z - distance * Math.cos(theta);
    let position = document.getElementById(elemento).getAttribute("position");
    position.x = planeX;
    position.y = pos.y;
    position.z = planeZ;
    //console.log(position);
    document.getElementById(elemento).setAttribute("position", position);
  };

  const validarEscenaExiste = (nombreEscena, proyecto) => {
    if (!proyecto || !proyecto.escenas) return false;
    return proyecto.escenas.some((escena) => escena.titulo === nombreEscena);
  };

  const getFunction = (e) => {
    //console.log("%c GET FUNCTION", "color: orange", e);
    switch (e.tipo) {
      case 0:
        return () => {
          if (playing) return;
          //if (isVRMode) return;

          //capturemos la metrica
          setInteractions((prevInteractions) => ({
            ...prevInteractions,
            video_button: prevInteractions.video_button + 1,
          }));

          if (!isVRMode) {
            if (!isVR) {
              setPopUpTitulo(e.nombre);
              let videoURL =
                e.video +
                (e.video && e.video.includes("?") ? "&" : "?") +
                "autoplay=1";
              if (iframe.current) iframe.current.src = videoURL;
              setPopUpContenido(
                <iframe
                  ref={!iframe.current ? iframe : null}
                  src={videoURL}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  width="100%"
                  height="350vh"
                />
              );

              setOpen(true);
              //console.log(e);
            } else {
              setPopUpTitulo(e.nombre);
              setMobileVideoSrc(e.video);
              //console.log(e.position);
              setVRPopUpPosition(e);
              videoControl.current.play();
              setPlaying(true);
            }
          } else {
            console.log(
              "%c CLICKING EN SHOW VIDEO VR",
              "color: yellow",
              proyecto.escenas[escenaIndex].titulo
            );
            //console.log(proyecto.escenas[escenaIndex].titulo === "START");
            //if (proyecto.escenas[escenaIndex].titulo === "Oficina Central") {
            if(proyecto.escenas[escenaIndex].titulo === "START"){

              setShowVideoVR((prev) => {
                const newValue = !prev;
                if (newValue) {
                  setPlaying(true);
                  setTimeout(() => {
                    setShowVideoVR(false);
                    setPlaying(false);
                  }, 94000);
                } else {
                  setPlaying(false);
                }
                return newValue;
              });
            }
          }
        };
      case 1:
        return () => {
          //capturemos la metrica
          setInteractions((prevInteractions) => ({
            ...prevInteractions,
            info_button: prevInteractions.info_button + 1,
          }));
          if (playing) return;
          //manejemos el contenido para tener un item de venta en info
          if (e.titulo === "item") {
            setPopUpTitulo("Oferta");
          } else if (e.titulo === "izquierda" || e.titulo === "derecha") {
            setPopUpTitulo("");
            //const camera = document.querySelector("#camara");
            // const currentPosition = camera.getAttribute("position");
            // camera.setAttribute("position", {
            //   x: currentPosition.x + 1, // Move 5cm right
            //   y: currentPosition.y,
            //   z: currentPosition.z,
            // });
          } else {
            setPopUpTitulo(e.titulo);
          }
          // Check if text contains URLs
          const urlRegex = /(https?:\/\/[^\s]+)/g;
          const hasUrl = urlRegex.test(e.texto);

          if (hasUrl && !isVRMode) {
            // If there's a URL, convert it to an HTML anchor
            const textWithLinks = e.texto.replace(
              urlRegex,
              '<a href="$1" target="_blank" rel="noopener noreferrer">link a compra</a>'
            );
            setPopUpContenido(
              <div dangerouslySetInnerHTML={{ __html: textWithLinks }} />
            );
          } else {
            // No URL, just set the text
            setPopUpContenido(e.texto);
          }
          //modificado isVR por isVRMode
          if (!isVRMode) {
            // console.log(
            //   "%c evento en elemento info y no modo VR",
            //   "color: orange"
            // );
            setOpen(true);
            //console.log(e);
          } else {
            // console.log(
            //   "%c evento en elemento info y modo VR",
            //   "color: yellow"
            // );
            setVRPopUpPosition(e);
            setPlaying(true);
            setTimeout(() => {
              setPlaying(false); // Desactiva `playing` después de 10 segundos
            }, 10000);
          }
          //agrego esta linea para prevenir la actualizacion indeseada y aleatoria
          return;
        };
      case 2:
        return () => {
          //console.log("%c IS MOBILE???", "color: yellow", isMobileXp);
          const isEncuesta = (e && e.encuesta && e.encuesta.visible) || false;
          //const isEncuesta = true;
          if (playing) return;

          const navegarAEscena = () => {
            if (e.escena) {
              if (!validarEscenaExiste(e.escena, proyecto)) {
                setPopUpTitulo("Error de Navegación");
                setPopUpContenido(
                  `La escena ${e.escena} se esta cargando o no existe en esta Experiencia.`
                );
                setOpen(true);
                return;
              }

              if (isMobileXp) {
                setTimeout(() => {
                  setEscena(e.escena, proyecto);
                }, 2000);
              } else {
                setEscena(e.escena, proyecto);
              }
            } else {
              setPopUpTitulo(e.nombre);
              setPopUpContenido("No hay una escena asociada a este link");
              setOpen(true);
            }
          };

          //encuesta
          if (isEncuesta && !isVRMode) {
            const manejarSeleccionOpcion = (
              indiceSeleccionado,
              encuesta,
              navegarCallback //es navegarEscena
            ) => {
              const indiceCorrecta = encuesta.opcionValida || 0;
              const esCorrecta = indiceSeleccionado === indiceCorrecta;

              if (esCorrecta) {
                // Mostrar éxito y navegar
                setPopUpTitulo("¡Correcto!");
                setPopUpContenido(
                  encuesta.respuestaTexto || "¡Respuesta correcta!"
                );
                setOpen(true);
                setTimeout(() => {
                  setOpen(false);
                  setEncuestaData((prev) => ({ ...prev, visible: false }));
                  navegarCallback();
                }, 2000);
              } else {
                // Mostrar error y permitir reintentar
                setPopUpTitulo("Intenta de nuevo");
                setPopUpContenido("Esa no es la respuesta correcta.");
                setOpen(true);
                setTimeout(() => setOpen(false), 2000);
              }
            };

            setEncuestaData({
              visible: true,
              pregunta:
                e.encuesta.pregunta || "¿Te gustaría responder una encuesta?",
              opciones: e.encuesta.opciones || ["Sí", "No"],
              opcionCorrecta: e.encuesta.opcionCorrecta || "Sí",
              onSeleccionarOpcion: (indice) => {
                manejarSeleccionOpcion(indice, e.encuesta, navegarAEscena);
              },
              // onRespuestaSi: () => {
              //   navegarAEscena();
              //   // Tu lógica aquí
              // },
              // onRespuestaNo: () => {
              //   console.log("Usuario respondió: NO");
              //   // Tu lógica aquí
              // },
              alCerrar: () =>
                setEncuestaData((prev) => ({ ...prev, visible: false })),
            });
            return;
          }

          navegarAEscena();

          // // Esperar 3 segundos antes de continuar
          // setTimeout(() => {
          //   setOpen(false);
          // }, 3000);

          // if (e.escena) {
          //   if (isMobileXp) {
          //     setTimeout(() => {
          //       setEscena(e.escena, proyecto);
          //     }, 2000);
          //   } else {
          //     setEscena(e.escena, proyecto);
          //   }
          // } else {
          //   setPopUpTitulo(e.nombre);
          //   setPopUpContenido("No hay una escena asociada a este link");
          //   setOpen(true);
          // }
        };
      case 3:
        return () => {
          //capturemos la metrica
          setInteractions((prevInteractions) => ({
            ...prevInteractions,
            image_button: prevInteractions.image_button + 1,
          }));
          if (playing) return;
          let origin_src = "";
          if (modo) {
            origin_src = e.imagen;
          } else {
            origin_src =
              process.env.REACT_APP_BASE_URL +
              "/tour360/uploads/files/" +
              proyecto.userId +
              "/" +
              proyecto.id +
              "/" +
              e.imagen;
          }
          //console.log("%c URL DE IMAGEN EN PLAYER", "color: teal", origin_src);
          if (e.imagen) {
            setPopUpTitulo(e.nombre);
            if (!isVR) {
              // setPopUpContenido(<img width="100%" src={e.imagen} />);
              setPopUpContenido(
                <img width="100%" src={origin_src} alt="imagen" />
              );
              setOpen(true);
            } else {
              setVRPopUpImage(e.imagen);
              //document.getElementById("imageURL").src = e.imagen;
              document.getElementById("imageURL").src = origin_src;
              setVRPopUpPosition(e);
              setPlaying(true);
            }
          }
        };
      default:
        return null;
    }
  };

  const calcularDistancia = (a, b) => {
    const dx = a.clientX - b.clientX;
    const dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const [dataGeoCapted, setDataGeoCapted] = useState(false);
  //state usado para habilitar botones de navegacion despues de carga total
  // Agregar un nuevo estado cerca de la línea 118
  const [navigationEnabled, setNavigationEnabled] = useState(false);

  useEffect(() => {
    const registerEventPageVisit = async (data) => {
      data = {
        ...data,
        additional: {
          ...data.additional,
          userAnonId,
          typeAccess,
        },
      };
      if (!pageVisited && data && !modo) {
        await apiService.trackEvent({
          type: ANALYTICS_EVENT_TYPE.PAGE_VISIT,
          experienceData: data,
          additional: { userAnonId },
        });
        setPageVisited(true);
      }
    };

    const getCountVisits = async (data) => {
      try {
        const res = await apiService.getVisitsByExperience(data.id);

        // controlar el error de caso 0
        const totalVisits = Number(res.totalRecords) || 0;
        //console.log("CANTIDAD DE VISITAS: ", totalVisits);
        setCountVisits(totalVisits);
      } catch (error) {
        console.log(error);
      }
    };

    if (proyecto) {
      registerEventPageVisit(proyecto);
      setTituloHtml(proyecto.nombre);
    }

    //manejo de tour automatico para los componentes react
    if (proyecto) {
      const banderaFirstTime = localStorage.getItem("firstTime");
      //manejo el valor de la bandera para futuras implementaciones de un botón habilitador o deshabilitador del tour
      if (banderaFirstTime === null || banderaFirstTime === "false") {
        setDesplegarMenu(true);
        driverObj.drive();
        localStorage.setItem("firstTime", "true");
      }
    }

    if (proyecto && !modo) {
      getCountVisits(proyecto);

      //disparo de auto tour o tour automatico
      //handleAutoTour();
    }

    if (proyecto) {
      setTimeout(() => {
        setIsAllLoaded(true);
        setNavigationEnabled(true); // Habilitar navegación después de cargar todo
      }, 6000);
    }
  }, [proyecto, pageVisited, modo]);

  //effect que implementa metrica de geolocalizacion e ip
  useEffect(() => {
    const registerGeoData = async (data) => {
      if (!dataGeoCapted && data && !modo) {
        const dataForSend = {
          id: proyecto.id,
          userId: proyecto.userId,
          additional: {
            latitud: data.latitude,
            longitud: data.longitude,
            ciudad: data.city,
            pais: data.country_name,
            continente: data.continent_name,
            idioma: data.language,
            proveedor: data.organization,
            estado_provincia: data.state_prov,
            //horario: data.time_zone,
            ip: data.ip,
            userAnonId,
            typeAccess,
          },
        };

        await apiService.trackEvent({
          type: ANALYTICS_EVENT_TYPE.GEOLOCATION,
          experienceData: dataForSend,
          additional: {},
        });
        //setDataGeoCapted(true);
      }
    };

    if (proyecto && !dataGeoCapted && !modo) {
      console.log("%c INICIO DE CAPTURA DE GEOLOCALIZACION", "color: teal", {
        dataGeoCapted,
      });
      setTimeout(async () => {
        const datosGeo = await metricasService.captureIP();
        await registerGeoData(datosGeo);
        setDataGeoCapted(true);
      }, 6000);
    }

    if (proyecto && !modo && proyecto.scripts) {
      const listFiltered = proyecto.scripts.filter(
        (oneScript) => oneScript && oneScript.habilitado
      );

      // Crear todos los scripts de una vez
      listFiltered.forEach((script) => {
        if (script.tipo !== "whatsapp") {
          const targetElement = document.querySelector(script.target || "head");
          const scriptElement = document.createElement("script");
          scriptElement.type = "text/javascript";
          scriptElement.async = true;

          if (script.tipo === "url") {
            scriptElement.src = script.url;
          } else if (script.tipo === "texto") {
            scriptElement.text = script.texto;
          }

          targetElement.appendChild(scriptElement);
        } else if (script.tipo === "whatsapp") {
          // Verificar si ya existe un botón de WhatsApp
          const existingWhatsappButton =
            document.querySelector('a[href*="wa.me"]');
          if (!existingWhatsappButton) {
            const whatsappObject = generateWhatsAppScript({
              phone: script.telefono,
              message: script.mensaje,
            });
            const scriptElement = whatsappObject.generateScript();
            document.body.appendChild(scriptElement);
          } else {
            console.log(
              "%c WhatsApp button ya existe, no se generará de nuevo",
              "color: orange"
            );
          }
        }
      });

      // Cleanup function
      return () => {
        listFiltered.forEach((script) => {
          const targetElement = document.querySelector(script.target || "head");
          const scripts = targetElement.getElementsByTagName("script");
          // Remover scripts que coincidan
          Array.from(scripts).forEach((scriptElement) => {
            if (script.tipo === "url" && scriptElement.src === script.url) {
              targetElement.removeChild(scriptElement);
            } else if (
              script.tipo === "texto" &&
              scriptElement.text === script.texto
            ) {
              targetElement.removeChild(scriptElement);
            }
          });
        });
      };
    }
  }, [proyecto]);

  // const insertScriptsInPlayer = (scriptsList) => {
  //   if (scriptsList && scriptsList.length > 0) {

  //   }
  // }

  const setFileData = (data) => {
    setProyecto({ ...data });
    let escenaPrincipal = data.escenas.find((e) => e.principal);
    //console.log("<<<<<<<<<<<<<<<<LA ESCENA PRINCIPAL ES ", escenaPrincipal);
    if (escenaPrincipal) {
      // Establecer el índice correcto inmediatamente para evitar flash
      let indicePrincipal = data.escenas.findIndex((e) => e.principal);
      setEscenaIndex(indicePrincipal);
      setEscena(escenaPrincipal.titulo, data);
    } else {
      // Si no hay escena principal, usar la primera
      setEscenaIndex(0);
      setEscena(0, data);
    }
  };

  const getProject = async () => {
    if (!location.proyectId) return;
    setCargando(true);

    //voy a buscar los datos de la experiencia en Api Backend
    try {
      //const dataStorage = JSON.parse( localStorage.getItem("authState"));
      const resFromApi = await apiService.getExperienceById(
        // dataStorage.griftin_token,
        location.proyectId
      );

      if (resFromApi) {
        setModo(false);
        const data = resFromApi;
        //  console.log("<<<<<<<<<DATOS DEL PROYECTO OBTENIDOS DEL API<<<<<<<<<<");
        // console.log(data);
        const dataForDisplay = {
          escenas: data.scenes.map((e) => {
            return {
              fondo: e.url,
              inicio: e.initial,
              principal: e.principal,
              titulo: e.title,
              elementos: e.elements,
            };
          }),
          id: data.id,
          userId: data.userId,
          isAnimated: data.isAnimated,
          linkUrl: data.metadata?.urlLink || "",
          nombre: data.name,
          otras360: data.metadata?.otras360 || [],
          redesSociales: {},
          titulo360: data.metadata?.titulo360 || "",
          sound: data.metadata?.sound || 1,
          scripts: data.metadata?.scripts || [],
          asistente: { habilitado: Boolean(data.metadata?.asistente?.habilitado) },
        };
        console.log("DATA DE DATAFORDISPLAY: ", dataForDisplay);
        setFileData(dataForDisplay);
        //registerEventPageVisit(dataForDisplay);
        setAnimateEnabled(data.isAnimated);
        setUrlLink(dataForDisplay.linkUrl);
        //console.log("otras360 antes del set: ", dataForDisplay.otras360);
        setTitulo360Value(dataForDisplay.titulo360);
        setRedesState(data.redesSociales);
        setLinksData(dataForDisplay.otras360);
        setSoundSelected(dataForDisplay.sound);
      } else {
        throw new Error("Esta Experiencia no existe en API");
      }
    } catch (error) {
      try {
        var a = await fetch(
          "https://codegstudio.com/apps/360/convertir.php?id=" +
            location.proyectId
        );
        // console.log(
        //   "<<<<<<<<<<<<<<<<<<<<<<<<<RESPUESTA AL FETCH DE CODEGSTUDIO: ",
        //   a
        // );
        if (!a.ok) {
          throw new Error(`Error en la respuesta del archivo: ${a.status}`);
        }
        a.json().then((data) => {
          setFileData(data);
          // console.log(
          //   "<<<<<<<<<DATOS DEL PROYECTO OBTENIDOS DEL FILE<<<<<<<<<<"
          // );
          // console.log(data);
          //   setCargando(false);
          setAnimateEnabled(data.isAnimated);
          setUrlLink(data.linkUrl);
          setTitulo360Value(data.titulo360);
          setRedesState(data.redesSociales);
          setLinksData(data.otras360);
        });
      } catch (error) {}
    } finally {
      setCargando(false);
    }
  };

  const isMobile = () => {
    document.querySelector("a-scene").addEventListener("enter-vr", function () {
      setIsVR(true);
    });

    document.querySelector("a-scene").addEventListener("exit-vr", function () {
      setIsVR(false);
    });

    if (!isMobileXp) {
      cursor.current.setAttribute(
        "cursor",
        "rayOrigin: mouse; fuse: true; fuseTimeout: 100"
      );
      cursor.current.setAttribute("visible", false);
    } else {
      //esto fue comentado cuando implemente mirilla con png
      cursor.current.setAttribute("cursor", "fuse: true; fuseTimeout: 1000");
      // cursor.current.setAttribute(
      //   "geometry",
      //   "primitive: ring; radiusInner: 0.02; radiusOuter: 0.03"
      // );
    }
    camara.current.setAttribute("wasd-controls", { enabled: false });
  };

  const setMouseEvents = () => {
    let rotationSpeed = 0.01;
    let tt = document.getElementById("tooltip");
    window.addEventListener("mousemove", (event) => {
      tt.style.left = event.pageX - 50 + "px";
      tt.style.top = event.pageY - 50 + "px";
    });

    window.addEventListener("wheel", (event) => {
      let delta = event.deltaY || event.detail || event.wheelDelta;
      zoomIn(delta < 0);
    });
    window.addEventListener("touchstart", (event) => {
      distanciaTouch = 0;
      let toques = Array.from(event.touches);
      if (toques.length > 1) {
        distanciaTouch = calcularDistancia(toques[0], toques[1]);
        // console.log("toques iniciales", distanciaTouch);
        // console.log(
        //   "toques iniciales",
        //   calcularDistancia(toques[0], toques[1])
        // );
      }
      if (toques.length == 1) {
        touchPos = { x: toques[0].clientX, y: toques[0].clientY };
        // console.log("starttouch", {
        //   x: toques[0].clientX,
        //   y: toques[0].clientY,
        // });
      }
    });

    window.addEventListener("touchend", (event) => {
      let toques = Array.from(event.changedTouches);
      //console.log("endtouch", event);
      if (toques.length == 1) {
        if (toques[0].clientX == touchPos.x && toques[0].clientY == touchPos.y)
          tapBackground();
        setDesplegarMenu((prev) => !prev);
      }
    });

    window.addEventListener("touchmove", (event) => {
      let toques = Array.from(event.touches);
      if (toques.length > 1) {
        let esAcercamiento =
          distanciaTouch < calcularDistancia(toques[0], toques[1]);
        zoomIn(esAcercamiento);
        //console.log("distancia", distanciaTouch);
      }
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        camara.current.components["look-controls"].yawObject.rotation.y +=
          rotationSpeed;
      } else if (e.key === "ArrowRight") {
        camara.current.components["look-controls"].yawObject.rotation.y -=
          rotationSpeed;
      } else if (e.key === "ArrowUp") {
        camara.current.components["look-controls"].pitchObject.rotation.x +=
          rotationSpeed;
      } else if (e.key === "ArrowDown") {
        camara.current.components["look-controls"].pitchObject.rotation.x -=
          rotationSpeed;
      }
    });

    window.addEventListener("click", (e) => {
      setAnimateEnabled(false);
      //setDesplegarMenu(prev => !prev);
      // console.log("showMenuFloat antes de cambiarlo", showMenuFloat);
      // setShowMenuFloat((prev) => {
      //   console.log("showMenuFloat adentro de setShowMenu es: ", prev);
      //   return !prev;
      // });
    });

    /*window.addEventListener('keyup', (e) => {
            if (e.key === 'ArrowLeft') {
              this.rotateLeft = false;
            } else if (e.key === 'ArrowRight') {
              this.rotateRight = false;
            }
          });*/
  };

  const cerrarPopUp = () => {
    setOpen(false);
    if (iframe.current) iframe.current.src = "";
    setPopUpContenido(null);
    setPlaying(false);
    setMobileVideoSrc("");
    document.getElementById("imageURL").src = "";
    setVRPopUpImage(null);
  };

  const tapBackground = () => {
    setDesplegarMenu((prev) => !prev);
    //let escenasContainer = document.getElementById("escenasContainer");
    // if (escenasContainer) {
    //   escenasContainer.classList.add("hidden-scenes");
    //   setShowCarrousel(false);
    // }

    //console.log("tapBackground", timeOutClick);

    // if (timeOutClick) return;
    // let banner = document.getElementById("banner");
    // let escenasContainer = document.getElementById("escenasContainer");
    // banner.classList.remove("hidden-menu");
    // let to = setTimeout(() => {
    //   console.log("intervalo");
    //   let banner = document.getElementById("banner");
    //   if (
    //     banner &&
    //     banner.classList &&
    //     !banner.classList.contains("hidden-menu")
    //   ) {
    //     banner.classList.add("hidden-menu");
    //     escenasContainer.classList.add("hidden-scenes");
    //   }
    //   setTimeOutClick(null);
    // }, 1000);
    // setTimeOutClick(to);
  };

  const viewScenasShortcut = () => {
    let escenasContainer = document.getElementById("escenasContainer");
    if (escenasContainer) {
      escenasContainer.classList.remove("hidden-scenes");
      setShowCarrousel(true);
    }
  };

  const hiddenScenasShortcut = () => {
    let escenasContainer = document.getElementById("escenasContainer");
    if (escenasContainer) {
      escenasContainer.classList.add("hidden-scenes");
      //escenasContainer.classList.remove("hidden-scenes");
      setShowCarrousel(false);
    }
  };

  const showTooltip = (e) => {
    let tt = document.getElementById("tooltip");
    tt.classList.remove("hidden");
    tt.innerHTML = e.nombre;
    //tt.style.left =
    /*
        tt.setAttribute('visible', true);
        tt.setAttribute('text', 'value', e.nombre);
        //setVRPopUpPosition(e, 'tooltip')
        tt.setAttribute('position', `${e.position.x-2} ${e.position.y} ${-12}`);*/
  };

  const hideTooltip = (e) => {
    let tt = document.getElementById("tooltip");
    tt.classList.add("hidden"); /*
        tt.setAttribute('visible', false);*/
  };

  useEffect(() => {
    //console.log("[PLAYER-VIEW]:::EFFECT", !location.proyectId);
    setMouseEvents();
    getProject();

    isMobile();
    ReactGA.event({
      category: "User",
      action: "onLoadExperience",
      data: {
        user_rol: "visitor",
      },
    });
    document.addEventListener("click", handleCardRelacionadas);
  }, []);

  useEffect(() => {
    //inicio variable startTime
    if (startTime === null) {
      setStartTime(Date.now());
    }
  }, []);

  //effect que maneja analiticas de tiempo de permanencia
  useEffect(() => {
    // Variables para tracking de tiempo en background
    let timeInBackground = 0;
    let backgroundStartTime = null;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // La página se ocultó (usuario cambió de pestaña o minimizó)
        backgroundStartTime = Date.now();
      } else {
        // La página se volvió visible
        if (backgroundStartTime !== null) {
          // Calculamos el tiempo que estuvo en background
          const backgroundDuration = Date.now() - backgroundStartTime;
          timeInBackground += backgroundDuration;
          console.log(
            "%c DURACION EN BACKGROUND: ",
            "color: yellow",
            timeInBackground
          );
          backgroundStartTime = null;
        }
      }
    };

    const handleBeforeUnload = async (event) => {
      const endTime = Date.now();
      //hago este tratamiento porque no quiero anular la metrica de interacciones por una falla
      //en la captura del tiempo de inicio
      if (startTime === null) {
        setStartTime(endTime);
        console.warn(
          "La Metrica de Permanencia es Nula, el tiempo de inicio no es válido."
        );
      }
      if (!proyecto) {
        console.warn(
          "La Metrica de Permanencia es Nula, el proyecto no existe."
        );
        return;
      }

      try {
        const duration = endTime - startTime;

        const activeTime = (duration - timeInBackground) / 1000;
        setSpentTime(activeTime);

        const objInteractions = interactions;

        const dataSpent = {
          id: proyecto.id,
          userId: proyecto.userId,
          additional: {
            timeSeconds: activeTime,
            userAnonId,
          },
        };

        const dataInteractions = {
          id: proyecto.id,
          userId: proyecto.userId,
          additional: {
            interactions: objInteractions,
            userAnonId,
          },
        };
        // await apiService.trackEvent({
        //        type: ANALYTICS_EVENT_TYPE.TIME_SPENT,
        //        experienceData: dataSpent,
        //      })

        await Promise.all([
          apiService.trackEvent({
            type: ANALYTICS_EVENT_TYPE.TIME_SPENT,
            experienceData: dataSpent,
          }),
          apiService.trackEvent({
            type: ANALYTICS_EVENT_TYPE.INTERACTIONS,
            experienceData: dataInteractions,
          }),
        ]);
      } catch (error) {
        console.error("Error al enviar datos:", error);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [proyecto, interactions, startTime]);

  useEffect(() => {
    //    console.log("ANIMACION HABILITADA?", animateEnabled);
  }, [animateEnabled]);

  useEffect(() => {
    // console.log(
    //   "%c PASANDO POR EFFECT DE SOUND SELECTED",
    //   "color: yellow",
    //   soundSelected
    // );
  }, [soundSelected]);

  //metodo que maneja el disparo de recorrido automatico
  const handleAutoTour = () => {
    // console.log(
    //   "%c AUTOMATIC TOUR",
    //   "color: orange; font-size:'22px",
    //   automaticTour
    // );
    if (
      !proyecto ||
      !proyecto.escenas ||
      proyecto.escenas.length === 0 ||
      !automaticTour
    ) {
      // console.log(
      //   "%c PROYECTO??",
      //   "color: orange; font-size:'22px",
      //   proyecto ? true : false
      // );
      // console.log(
      //   "%c ESCENAS??",
      //   "color: orange; font-size:'22px",
      //   proyecto.escenas ? true : false
      // );
      // console.log(
      //   "%c EN AUTOMATIC TOUR PASO POR RETURN",
      //   "color: orange; font-size:'22px"
      // );
      return;
    }

    // console.log(
    //   "%c EN AUTOMATIC TOUR PASO POR CUMPLE LAS CONDICIONES",
    //   "color: orange; font-size:'22px"
    // );
    navigationAction(proyecto, escenaIndex, setEscenaIndex);
  };

  useEffect(() => {
    if (
      proyecto &&
      proyecto.escenas &&
      proyecto.escenaslength !== 0 &&
      automaticTour
    ) {
      // console.log(
      //   "%c PASANDO POR EFFECT DE ESCENA INDEX PARA TOUR AUTOMATICO",
      //   "color: blue; font-size:'22px"
      // );
      handleAutoTour();
    }
  }, [escenaIndex, proyecto]);

  //nuevo metodo que dispara enterVR
  // const actionEnterVR = () => {
  //   const scene = document.querySelector("a-scene");
  //   console.log("%c DATA DE ESCENA AL MOMENTO DE ENTRAR A VR ", "color: orange", proyecto.escenas[escenaIndex]);

  //   if (scene && scene.enterVR) {
  //     // Get initial rotation values from current scene
  //     const sceneData = proyecto.escenas[escenaIndex];
  //     const initialX = sceneData.inicio ? sceneData.inicio.x : 0;
  //     const initialY = sceneData.inicio ? sceneData.inicio.y : 0;

  //     // Convert to radians with proper adjustments (similar to setEscena method)
  //     const valorX = (initialX * Math.PI) / 180;
  //     const valorY = ((initialY * Math.PI) / 180) * -1; // Note the -1 multiplier for Y rotation

  //     // Enter VR mode
  //     scene.enterVR().then(() => {
  //       // After entering VR, apply rotation with a delay to ensure VR is initialized
  //       setTimeout(() => {
  //         // Get camera components similar to navigationAction.js approach
  //         const camera = document.querySelector("#camara");
  //         if (camera && camera.components && camera.components["look-controls"]) {
  //           // Apply rotation directly to the look-controls components
  //           camera.components["look-controls"].pitchObject.rotation.x = valorX;
  //           camera.components["look-controls"].yawObject.rotation.y = valorY;

  //           console.log("%c Applied initial rotation in VR mode", "color: green",
  //             { pitchDeg: initialX, yawDeg: initialY, pitchRad: valorX, yawRad: valorY });
  //         } else {
  //           // Fallback to direct object3D rotation if look-controls aren't available
  //           document.querySelector("#cameraWrapper").object3D.rotation.set(
  //             valorX, valorY, 0
  //           );
  //         }
  //       }, 800); // Slightly longer delay to ensure VR is fully initialized
  //     }).catch(err => {
  //       console.error("Error entering VR mode:", err);
  //     });
  //   }
  // };
  const actionEnterVR = async () => {
    const scene = document.querySelector("a-scene");
    console.log(
      "%c DATA DE ESCENA AL MOMENTO DE ENTRAR A VR ",
      "color: orange",
      proyecto.escenas[escenaIndex]
    );

    // El modo VR pone el canvas en presentación/fullscreen: el diálogo nativo
    // de permiso de micrófono no se ve ahí adentro. Lo disparamos ahora, con
    // el DOM todavía visible, para que @11labs/client no falle en silencio
    // al iniciar sesión desde dentro del visor.
    if (elevenLabsAgentId) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop());
      } catch (err) {
        console.error("Permiso de micrófono denegado, VR sin asistente de voz:", err);
      }
    }

    if (scene && scene.enterVR) {
      scene.enterVR();
    }

    // Obtener la posición de la cámara
    // var camDetected = camara.current.object3D;
    // console.log('Is this a camera?', camDetected instanceof THREE.Camera);
    // const camPos = camDetected.position;
    // const camX = camPos.x;
    // const camZ = camPos.z;

    // if (scene && scene.enterVR) {
    //   // Get target rotation values from current scene
    //   const targetX = proyecto.escenas[escenaIndex].inicio
    //     ? proyecto.escenas[escenaIndex].inicio.x
    //     : 0;
    //   const targetY = proyecto.escenas[escenaIndex].inicio
    //     ? proyecto.escenas[escenaIndex].inicio.y
    //     : 0;
    //   // Get initial rotation values from current scene
    //   const sceneData = proyecto.escenas[escenaIndex];
    //   const initialX = sceneData.inicio ? sceneData.inicio.x : 0;
    //   const initialY = sceneData.inicio ? sceneData.inicio.y : 0;

    //   // Convert to radians with proper adjustments (similar to setEscena method)
    //   const valorX = (initialX * Math.PI) / 180;
    //   const valorY = ((initialY * Math.PI) / 180) * -1; // Note the -1 multiplier for Y rotation

    //   // Enter VR mode
    //   scene.enterVR().then(() => {
    //     // After entering VR, set up the animation
    //     // After entering VR, apply rotation with a delay to ensure VR is initialized
    //     const rotX = THREE.MathUtils.degToRad(targetX);
    //     // const rotY = THREE.MathUtils.degToRad(targetY) * 2;
    //     console.log(
    //       "%c punto de inicio establecido",
    //       "color: teal",
    //       proyecto.escenas[escenaIndex].inicio.x,
    //       proyecto.escenas[escenaIndex].inicio.y
    //     );
    //     const rotY = Math.atan2(targetX - camX, initialY - camZ);
    //     console.log("%c POSICION CAMARA INICIAL", "color: blue", camX, camZ);
    //     console.log("%c ROTACIONES", "color: orange", rotX, rotY);
    //     // setTimeout(() => {
    //     //   document
    //     //     .querySelector("#cameraWrapper")
    //     //     .object3D.rotation.set(0, rotY, 0);
    //     // }, 500); // Short delay to ensure VR mod
    //     // Create camera animation
    //     setTimeout(() => {
    //       const camera = camara.current.components.camera;
    //       const cameraWrapper = document.querySelector("#cameraWrapper").object3D;

    //       if (camera) {
    //         console.log('Camera component found:', camera);
    //         const cameraObject = camera.camera; // This is the THREE.Camera object
    //         if (cameraObject instanceof THREE.Camera) {
    //           console.log("%c Camera is a THREE.Camera", "color: green");
    //           const startTime = Date.now();
    //           const duration = 10000; // 10 seconds total
    //           const rotations = 10; // Number of complete rotations

    //           const animate = () => {
    //             const now = Date.now();
    //             const elapsed = now - startTime;
    //             if (elapsed < duration) {
    //               // Calculate current rotation progress (0 to 10 * 2PI)
    //               const progress = (elapsed / duration) * rotations * Math.PI * 2;
    //               // Update both camera and wrapper rotations
    //               const rotation = new THREE.Euler(0, progress, 0, 'YXZ');
    //               cameraObject.setRotationFromEuler(rotation);
    //               cameraWrapper.setRotationFromEuler(rotation);

    //               cameraObject.updateProjectionMatrix();
    //               requestAnimationFrame(animate);
    //             }
    //           };

    //           animate();
    //           cameraObject.updateProjectionMatrix();
    //         }
    //       }
    //       if (camera instanceof THREE.Camera) {
    //         // Convert rotations to radians
    //         const rotation = new THREE.Euler(0, Math.PI, 0, 'YXZ');
    //         camera.setRotationFromEuler(rotation);
    //         cameraWrapper.setRotationFromEuler(rotation);
    //         camera.updateProjectionMatrix();
    //       } else {
    //         // Fallback to look-controls if not a THREE.Camera
    //         const lookControls = camara.current.components["look-controls"];
    //         if (lookControls) {
    //           lookControls.yawObject.rotation.y = Math.PI;
    //           lookControls.pitchObject.rotation.x = 0;
    //           // Sync wrapper rotation with look-controls
    //           cameraWrapper.rotation.y = Math.PI;
    //         }
    //       }
    //     }, 800);
    //   });
    // }
  };

  //metodo que salida de modo VR
  const handleExitVR = () => {
    if (escena.current) {
      escena.current.exitVR();
      setFullscreen();
    }
    // const scene = document.querySelector("a-scene");
    // if (scene && scene.exitVR) {
    //   scene.exitVR();
    // }
  };

  const onConfirmExitVR = () => {
    setShowModalVR(false);
    handleExitVR();
  };

  const onCancelExitVR = () => {
    setShowModalVR(false);
  };

  //manejo de url para sonido
  const fullUrl = window.location.href;
  const url = new URL(fullUrl);
  const baseDomainSound = `${url.protocol}//${url.hostname}`;

  //states para popUp de encuesta
  //const [openEncuesta, setOpenEncuesta] = useState(false);
  const [encuestaData, setEncuestaData] = useState({
    visible: false,
    pregunta: "",
    opcionCorrecta: 0,
    opciones: [],
    respuesta: "",
    onSeleccionarOpcion: () => {},
    alCerrar: () =>
      setEncuestaData((prev) => {
        return {
          ...prev,
          visible: false,
        };
      }),
  });
  // //metodo que maneja el disparo de recorrido automatico

  return (
    <>
      {" "}
      <Helmet>
        <title>{`Inmersial - ${tituloHtml}`}</title>
      </Helmet>
      <LoadingSpin visible={cargando} />
      <OpenProject visible={!location.proyectId} setFileData={setFileData} />
      <PopUpMsg
        visible={open}
        titulo={popUpTitulo}
        contenido={popUpContenido}
        alCerrar={cerrarPopUp}
      />
      {/* <PopUpMsg
        visible={open}
        titulo={popUpTitulo}
        contenido={popUpContenido}
        alCerrar={cerrarPopUp}
      /> */}
      <PopUpEncuesta
        visible={encuestaData.visible}
        pregunta={encuestaData.pregunta}
        opciones={encuestaData.opciones} // Agregar esta línea
        opcionCorrecta={encuestaData.opcionCorrecta} // Agregar esta línea
        onSeleccionarOpcion={encuestaData.onSeleccionarOpcion} // Agregar esta línea
        alCerrar={encuestaData.alCerrar}
      />
      {isAllLoaded && (
        <EscenasMenu
          escenas={proyecto ? proyecto.escenas : []}
          setEscena={(e) => setEscena(e, proyecto)}
          hiddenScenasShortcut={hiddenScenasShortcut}
          escenaIndex={escenaIndex}
        />
      )}
      <div id="tooltip" className="hidden"></div>
      {!cargando && proyecto && !open && !playing && (
        <div id="banner" className="hidden-menu">
          {/* <div
              className="controlbutton"
              id="zoominbutton"
              onClick={() => zoomIn(true)}
            ></div>
            <div
              className="controlbutton"
              id="zoomoutbutton"
              onClick={() => zoomIn(false)}
            ></div> */}
          {/* <div
              className="controlbutton"
              id="fullscreenbutton"
              onClick={setFullscreen}
            ></div> */}
          {/* <div
              className="controlbutton"
              id="linkbutton"
              onClick={handleClickLinkButton}
            ></div> */}
          {/* <div
              className="controlbutton"
              id="vrbutton"
              ref={vrbutton}
              onClick={setVR}
              style={{ display: isMobileXp ? "block" : "none" }}
            ></div> */}
          {/* <div
              className="controlbutton"
              id="shortcutbutton"
              ref={vrbutton}
              onClick={viewScenasShortcut}
            >
              <ApartmentOutlined style={{ fontSize: 45 }} />
            </div> */}
        </div>
      )}
      <a-scene
        ref={escena}
        onMouseDown={(e) => {
          if (e.clientX != undefined)
            setMousePos({ x: e.clientX, y: e.clientY });
        }}
        onMouseUp={(e) => {
          if (
            e.clientX != undefined &&
            e.clientX == mousePos.x &&
            e.clientY == mousePos.y
          )
            tapBackground();
        }}
      >
        <a-assets>
          <img id="plus" src={info} alt="plus" />
          <img id="dollar" src={dollar_icon} alt="dollar" />
          <img id="flechaDerecha" src={flecha_derecha} alt="flechaDerecha" />
          <img
            id="flechaIzquierda"
            src={flecha_izquierda}
            alt="flechaIzquierda"
          />
          <img id="gafas" src={gafas_white} alt="gafas" />
          <img id="playvideo" src={video} alt="playvideo" />
          <img id="image" src={image} alt="imageAlt" />
          <img id="imageURL" src="" alt="imageURL" crossorigin="anonymous" />
          {/* <audio id="backgroundSound" src={`${baseDomainSound}/sounds/piano.ogg`} preload="none"></audio> */}
          {/* <audio
            id="backgroundSound"
            src={`${process.env.REACT_APP_BASE_URL}/tour360/uploads/files/9a803c28-3f4f-4eb1-899e-3c0b054ab7f4/3d3e9e50-07e6-47b2-9360-bda2b3e66865/triste.mp3`}
            preload="none"
          ></audio> */}
          <video
            id="video-1"
            src={video1}
            preload="auto"
            loop="true"
            crossorigin="anonymous"
            playsinline
            webkit-playsinline
            autoplay
            muted
          ></video>
          {/* <img id="play" src={playv} alt="play" /> */}
          <img id="closeVideo" src={close} alt="close video" />

          {soundSelected > 0 && (
            <audio
              // key={`audio-${soundSelected}`}
              key={`entity-${soundSelected}`}
              id="backgroundSound"
              src={`${baseDomainSound}/sounds/${
                soundSelected === 1
                  ? "ambiental.ogg"
                  : soundSelected === 2
                  ? "piano.ogg"
                  : soundSelected === 3
                  ? "jazz.ogg"
                  : ""
              }`}
              preload="none"
            />
          )}

          <img id="exitIcon" src="exitPng" alt="" />

          {/* <img id="textura_madera" src={textura_madera} alt="textura madera" /> */}

          <img id="folletoImg" src={folleto} alt="folleto img" />
          <img id="cursorIcon" src={cursor_icon} alt="cursor icon" />
          <video
            ref={videoControl}
            id="videocontrol"
            width="100%"
            src={mobileVideoSrc}
            controls
            autoPlay
            preload="none"
          />

          <img id="portalImg" src={portal} alt="portal img" />
          <img id="phoneIcon" src={phoneIcon} alt="phone icon" />
          {proyecto && proyecto.escenas.length > 0 && (
            <img
              crossorigin="anonymous"
              key="escena0"
              id="escena0"
              src={proyecto.escenas[0].fondo}
              alt="escena0"
            />
          )}
        </a-assets>
        <a-sky
          ref={cielo}
          id="cielo"
          src={
            proyecto && proyecto.escenas.length && escenaIndex !== null
              ? proyecto.escenas[escenaIndex].fondo
              : ""
          }
          rotation="0 90 0"
          material="opacity: 1; transparent:true"
          animation__fade_in="property: material.opacity; from: 0; to: 1; dur: 1500; startEvents: fadein"
          animation__fade_out="property: material.opacity; from: 1; to: 0; dur: 500; startEvents: fadeout"
        />
        {/* Sound entity will render conditionally based on isSoundPlaying from VisitasComponent */}
        {/* {soundSelected > 0 && isSoundPlaying && (         */}
        {soundSelected > 0 && isSoundPlaying && (
          <a-entity
            key={`entity-${soundSelected}`}
            id="sound-entity"
            sound={`src: #backgroundSound; loop: true; autoplay: false; positional: false; volume: 0.5`}
          ></a-entity>
        )}
        <a-entity id="cameraWrapper" position="0 0 0">
          <a-camera
            id="camara"
            ref={camara}
            animation={`property: rotation; from: 0 0 0; to: 0 360 0; dur: 800000; loop: true; easing:linear; enabled: ${animateEnabled};`}
          >
            <a-cursor
              position="0 0 -1"
              id="cursor"
              ref={cursor}
              cursor={`fuse: true; fuseTimeout: 100; ${isVRMode ? "rayOrigin: mouse; visible: false" : ""}`}
              raycaster="objects: .objeto"
              //geometry="primitive: ring; radiusInner: 0.2"
              geometry="primitive: ring; radiusInner: 0.2; radiusOuter: 0.5"
              material="shader:flat; src: #cursorIcon; transparent:true; color: #E94E1B"
              scale="0.07 0.07 0.07"
            />
            {isVRMode && (
              <>
                {/* cursor para VR con controller */}
                <a-entity
                  cursor="fuse: true; fuseTimeout: 1000"
                  rayOrigin="controller"
                  raycaster="objects: .interactable; showLine: true; debug: true"
                  position="0 0 -1"
                  geometry="primitive: ring; radiusInner: 0.5"
                  material="shader:flat; src: #cursorIcon; transparent:true; color: #E94E1B"
                  scale="0.03 0.03 0.03"
                  visible={isVRMode}
                ></a-entity>
                {/* cursor por mirada (gaze) para VR sin controller (telefonos, cardboard) */}
                <a-entity
                  cursor="fuse: true; fuseTimeout: 1500; rayOrigin: entity"
                  raycaster="objects: .interactable"
                  position="0 0 -1"
                  geometry="primitive: ring; radiusInner: 0.3; radiusOuter: 0.5"
                  material="shader:flat; src: #cursorIcon; transparent:true; color: #E94E1B"
                  scale="0.05 0.05 0.05"
                ></a-entity>
              </>
            )}
          </a-camera>
        </a-entity>
        {/* icono del asistente con hud-follow: siempre delante del usuario
            (sigue el yaw), alcanzable por el gaze reticle en cualquier ambiente */}
        {isVRMode && elevenLabsAgentId && !proyecto?.asistente?.habilitado && (
          <ElevenLabsVR
            status={elevenLabsStatus}
            onToggle={handleElevenLabsToggle}
          />
        )}
        <a-mixin
          id="msg-button"
          geometry="primitive: circle; radius:2;"
          // animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          // animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          animation__rotate="property: rotation; dur:3000; to: 0 360 0; easing:linear; startEvents: mouseenter"
          material="color: #E94E1B; opacity: 1; transparent: true; shader: flat; src: #plus; side: double"
          animation="property: scale; to: 1.5 1.5 1.5; dir: alternate; dur: 3000; easing: easeInOutQuad; loop: true"
          //text="font: #fontRoboto"
          clickeable
        ></a-mixin>
        <a-mixin
          id="dollar-button"
          geometry="primitive: circle; radius:2;"
          animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          material="color: #E94E1B; opacity: 1; transparent: true; shader: flat; src: #dollar; side: double"
          //text="font: #fontRoboto"
          clickeable
        ></a-mixin>
        <a-mixin
          id="flecha-derecha-button"
          geometry="primitive: circle; radius:4;"
          // animation="property: position; to: 0 0.9 0; dur: 1000; dir: alternate; loop: true"
          animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          material="color: #E94E1B; opacity: 1; transparent: true; shader: flat; src: #flechaDerecha; side: double"
          //text="font: #fontRoboto"
          clickeable
        ></a-mixin>
        <a-mixin
          id="flecha-izquierda-button"
          geometry="primitive: circle; radius:4;"
          // animation="property: position; to: 0 -0.9 0; dur: 1000; dir: alternate; loop: true"
          animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          material="color: #E94E1B; opacity: 1; transparent: true; shader: flat; src: #flechaIzquierda; side: double"
          //text="font: #fontRoboto"
          clickeable
        ></a-mixin>
        <a-mixin
          id="view-button"
          //geometry="primitive: circle; radius:5"
          geometry="primitive: ring; radiusInner: 0; radiusOuter: 2"
          material="color: #E94E1B; opacity: 0; transparent: true; shader: flat; side: double"
          // material="shader:flat; src: #gafas; transparent:true; color: #E94E1B"
          scale="3 3 3"
          //scale="1.5 1.5 1.5"
          //geometry="primitive: ring; radiusInner: 1; radiusOuter: 2; segmentsTheta: 32"
          //material="color: #E94E1B; opacity: 1; transparent:true; shader: flat; src: #gafas; side: double"
          //material="color: #E94E1B; opacity: 1; transparent:true; shader: flat; side: double"

          animation__scale="property: scale; to: 4 4 4; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 3 3 3; dur: 200; startEvents: mouseleave"
          // animation="property: rotation; dur:3000; to: 0 360 0; easing:linear; loop:true"
          //animation__scale="property: scale; from: 0.5 0.5 0.5; to: 0.8 0.8 0.8; dir: alternate; dur: 3000; easing: easeInOutQuad; loop: true"
          // animation__scale="property: scale; from: 1 1 1; to: 1.2 1.2 1.2; dir: alternate; dur: 3000; easing: easeInOutQuad; loop: true"
          //animation__fade="property: material.opacity; from: 1; to: 2; dir: alternate; dur: 400; easing: easeInSine; loop: true"
          clickeable
        ></a-mixin>
        <a-mixin
          id="video-button"
          geometry="primitive: circle; radius:2;"
          material="color: #E94E1B; opacity: 0.5; transparent: true; shader: flat; src: #playvideo; side: double"
          // animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          // animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          animation__rotate="property: rotation; dur:3000; to: 0 360 0; easing:linear; startEvents: mouseenter"
          animation="property: scale; to: 2.7 2.7 2.7; dir: alternate; dur: 3000; easing: easeInOutQuad; loop: true"
          border="sides: 4; radius: 25; wall: #rail;"
          clickeable
        ></a-mixin>
        <a-mixin
          id="image-button"
          geometry="primitive: circle; radius:3;"
          material="color: #E94E1B; opacity: 1; transparent: true; shader: flat; src: #image; side: double"
          animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          border="sides: 4; radius: 25; wall: #rail;"
          clickeable
        ></a-mixin>
        <a-mixin
          id="portal"
          geometry="primitive: circle; segments: 32"
          material=" transparent: true; opacity: 0.2"
          //raycastable
          animation__scale="property: scale; to: 1.2 1.2 1.2; dur: 200; startEvents: mouseenter"
          animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
          // animation__mouseenterscale="property: scale; from: 1 1 1; to: 1.1 1.1 1.1; easing: easeInOutQuad; dir: alternate; loop: true; startEvents: mouseenter; dur: 1000; pauseEvents: mouseleave"
          scale="0.6 0.6 0.6"
        ></a-mixin>
        <a-mixin
          id="hoverAnimation"
          animation="property: object3D.position.y; from: -1.8; to: -1; dir: alternate; loop: true; dur: 5000; easing: easeInOutCubic; pauseEvents: touched"
        ></a-mixin>

        {/* banner animado para ofertas */}
        {/* <BannerAnimated imageId="folletoImg" />   */}

        <a-plane
          id="player"
          width="42"
          height="32"
          look-at="#camara"
          position={mobilePlayerPos}
          visible={playing}
          material="color: black; transparent: true; opacity: 0.6"
          //material="color: white"
        >
          {/* <a-entity
            position="1.5 8.5 10"
            text={
              "shader: msdf; anchor: center; width: 30; font: /fonts/custom-font-msdf/customFontAframe-msdf.json; font-image: /fonts/custom-font-msdf/customFontAframe.png; color: black; value: " +
              popUpTitulo
            }
          /> */}
          <a-text
            position="1.5 8.5 10"
            shader="msdf"
            anchor="center"
            width="30"
            font="/fonts/custom-font-msdf/customFontAframe-msdf.json"
            font-image="/fonts/custom-font-msdf/customFontAframe.png"
            negate="false"
            color="white"
            baseline="top"
            opacity="1"
            transparent="false"
            value={popUpTitulo}
          />

          {!popUpContenido && !VRPopUpImage && (
            <a-video
              src="#videocontrol"
              width="37"
              height="23"
              rotation="0 0 0"
              position="0 0 1"
              visible={!popUpContenido && !VRPopUpImage}
              border="sides: 4; radius: 25; wall: #rail;"
            ></a-video>
          )}
          {VRPopUpImage && (
            <Entity
              width="37"
              height="23"
              rotation="0 0 0"
              position="0 0 1"
              visible={VRPopUpImage}
              geometry="primitive: plane; height: 23; width: 37"
              material="shader: flat; src: #imageURL; side: double"
              border="sides: 4; radius: 25; wall: #rail;"
            ></Entity>
          )}
          {popUpContenido && (
            <Entity
              position="-12.5 2.5 10"
              visible={popUpContenido}
              text={
                popUpContenido
                  ? "shader: msdf; negate: false; baseline: top; anchor: left; width: 25; font: /fonts/custom-font-msdf/customFontAframe-msdf.json; font-image: /fonts/custom-font-msdf/customFontAframe.png; color: white; value: " +
                    popUpContenido
                  : ""
              }
            />
          )}
          <Entity
            position="8 -10 10"
            className="objeto interactable"
            animation__scale="property: scale; to: 1.5 1.5 1.5; dur: 200; startEvents: mouseenter"
            animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
            text="shader: msdf; anchor: left; width: 30; font: /fonts/custom-font-msdf/customFontAframe-msdf.json; negate: false; font-image: /fonts/custom-font-msdf/customFontAframe.png; color: white; value: X"
            events={{
              click: cerrarPopUp,
            }}
          />
        </a-plane>
        {/*<Entity
              id="tooltip"
              visible={false}
              text="shader: msdf; anchor: left; width: 40; font: https://cdn.aframe.io/examples/ui/Viga-Regular.json; color: white; value: ok"
                  />*/}
        {proyecto && proyecto.escenas.length
          ? proyecto.escenas[escenaIndex].elementos.map((e, k) => {
              let position = proyecto.escenas.findIndex(
                (es) => es.titulo === e.escena
              );
              //evitamos error de no existencia de escena
              if (position < 0) position = 0;

              // CASO ESPECIAL: view-button como elemento compuesto
              // if (getTipo(e) === "view-button") {
              //   return (
              //     <Entity
              //       key={k}
              //       position={`${e.position.x} ${e.position.y} ${e.position.z}`}
              //       rotation={`${e.rotation.x} ${e.rotation.y} ${e.rotation.z}`}
              //       mixin="view-button"
              //       {...(e.tipo === 2
              //         ? { [`to-scene-${position}`]: true }
              //         : {})}
              //       id={e.id}
              //       className="objeto interactable"
              //       visible={!playing}
              //       events={{
              //         click: getFunction(e),
              //         mouseenter: (s) => {
              //           showTooltip(e);
              //         },
              //         mouseleave: () => {
              //           hideTooltip(e);
              //         },
              //       }}
              //     >
              //       {/* Ring exterior */}
              //       <a-entity
              //         geometry="primitive: ring; radiusInner: 1; radiusOuter: 2; segmentsTheta: 32"
              //         material="color: #E94E1B; opacity: 0.9; transparent: true; shader: flat; side: double"
              //         animation__hover="property: scale; to: 1.1 1.1 1.1; dur: 200; startEvents: mouseenter"
              //         animation__hover_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
              //         events={{
              //           click: getFunction(e),
              //           mouseenter: (s) => {
              //             showTooltip(e);
              //           },
              //           mouseleave: () => {
              //             hideTooltip(e);
              //           },
              //         }}
              //       />

              //       {/* Icono interior */}
              //       <a-entity
              //         geometry="primitive: circle; radius: 1.5"
              //         material="color: #FFFFFF; transparent: true; shader: flat; src: #gafas; side: double"
              //         position="0 0 0.01"
              //         animation__pulse="property: scale; from: 0.9 0.9 0.9; to: 1.1 1.1 1.1; dir: alternate; dur: 1500; easing: easeInOutQuad; loop: true"
              //         {...(e.tipo === 2 ? { [`to-scene-${position}`]: true } : {})}
              //          events={{
              //           click: getFunction(e),
              //           mouseenter: (s) => {
              //             showTooltip(e);
              //           },
              //           mouseleave: () => {
              //             hideTooltip(e);
              //           },
              //         }}
              //       />
              //     </Entity>
              //   );
              // }

              return (
                // <a-entity
                //   key={k}
                //   position={`${e.position.x} ${e.position.y} ${e.position.z}`}
                //   rotation={`${e.rotation.x} ${e.rotation.y} ${e.rotation.z}`}
                // >
                <Entity
                  key={k}
                  position={`${e.position.x} ${e.position.y} ${e.position.z}`}
                  rotation={`${e.rotation.x} ${
                    e.position.x < 0 && e.titulo === "derecha"
                      ? e.rotation.y + 180
                      : e.position.z > 0 && e.titulo === "izquierda"
                      ? e.rotation.y + 180
                      : e.tipo === 1 && e.position.z > 0
                      ? e.rotation.y + 180
                      : e.tipo === 0 && e.position.z > 0
                      ? e.rotation.y + 180
                      : e.rotation.y
                  } ${e.rotation.z}`}
                  // rotation={`${e.rotation.x} ${e.rotation.y} ${e.rotation.z}`}
                  animation__arrows={`property: position; from: ${
                    e.position.x
                  } ${e.position.y} ${e.position.z}; to: ${
                    e.position.x - 0.9
                  } ${e.position.y} ${
                    e.position.z
                  }; dur: 1000; dir: alternate; loop: true; enabled: ${
                    e.titulo === "derecha" || e.titulo === "izquierda"
                  }`}
                  mixin={
                    getTipo(e) === "msg-button" && e.titulo === "item"
                      ? "dollar-button"
                      : getTipo(e) === "msg-button" && e.titulo === "derecha"
                      ? "flecha-derecha-button"
                      : getTipo(e) === "msg-button" && e.titulo === "izquierda"
                      ? "flecha-izquierda-button"
                      : getTipo(e)
                  }
                  {...(e.tipo === 2 ? { [`to-scene-${position}`]: true } : {})}
                  id={e.id}
                  className="objeto interactable"
                  visible={
                    //!playing
                    getTipo(e) !== "video-button"
                      ? !playing
                      : !isVRMode
                      ? !playing
                      : !playing &&
                        proyecto.escenas[escenaIndex].titulo ===
                          "START"
                    //(getTipo(e)
                    //getTipo(e) === "video-button" &&  proyecto.escenas[escenaIndex].titulo === "Oficina Central"
                    //   ? !playing
                    //   : !isVRMode && !playing
                  }
                  events={{
                    //click: getFunction(e),
                    click:
                      getTipo(e) === "msg-button" &&
                      (e.titulo === "derecha" || e.titulo === "izquierda")
                        ? () => {
                            const camera = camara.current;
                            const controls = camera.components["look-controls"];

                            if (controls) {
                              //manejo de posicion en el eje z
                              //const currentPositionZ = e.position.z;

                              //manejo de rotación
                              let rotationAmount = 0;
                              const duration = 1000; // Animation duration in milliseconds
                              const startY = controls.yawObject.rotation.y;
                              rotationAmount =
                                e.titulo === "derecha" ? -0.5 : 0.5;

                              // if (currentPositionZ < 0) {
                              //   // console.log("%c currentPositionZ < 0", "color: red", currentPositionZ);
                              //   // console.log("%c ROTACIÓN ACTUAL EN Y", "color: teal", controls.yawObject.rotation.y);
                              // } else {
                              //   // console.log("%c currentPositionZ > 0", "color: red", currentPositionZ);
                              //   // console.log("%c ROTACIÓN ACTUAL EN Y", "color: teal", controls.yawObject.rotation.y);
                              //   rotationAmount =
                              //   e.titulo === "derecha" ? -0.5 : 0.5;
                              // }

                              //const endY = startY + rotationAmount;
                              const startTime = Date.now();

                              function animate() {
                                const currentTime = Date.now();
                                const elapsed = currentTime - startTime;
                                const progress = Math.min(
                                  elapsed / duration,
                                  1
                                );

                                // Use easeInOutQuad easing function for smooth animation
                                const easeProgress =
                                  progress < 0.5
                                    ? 2 * progress * progress
                                    : 1 - Math.pow(-2 * progress + 2, 2) / 2;

                                controls.yawObject.rotation.y =
                                  startY + rotationAmount * easeProgress;

                                if (progress < 1) {
                                  requestAnimationFrame(animate);
                                }
                              }

                              animate();
                            }
                          }
                        : e.tipo === 2
                        ? navigationEnabled
                          ? getFunction(e)
                          : () => {}
                        : getFunction(e),
                    mouseenter: (s) => {
                      showTooltip(e);
                    },
                    mouseleave: () => {
                      hideTooltip(e);
                    },
                  }}
                >
                  {e.tipo === 2 && (
                    <>
                      <a-entity
                        geometry="primitive: ring; radiusInner: 1; radiusOuter: 1.5; segmentsTheta: 32"
                        material="color: #E94E1B; opacity: 1; transparent: false; shader: flat; side: double"
                        // rotation={`${e.rotation.x} ${
                        //   e.position.x < 0 && e.position.z > 0
                        //     ? e.rotation.y + 360
                        //     :  e.position.x > 0 && e.position.z < 0
                        //     ? e.rotation.y + 360
                        //     : e.position.x > 0 && e.position.z > 0? e.rotation.y + 180:
                        //     e.rotation.y
                        // } ${e.rotation.z}`}
                        // animation__hover="property: scale; to: 1.1 1.1 1.1; dur: 200; startEvents: mouseenter"
                        // animation__hover_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
                        // animation__rotate="property: rotation; to: 0 0 360; dur: 200; easing: linear; loop: true"
                        // events={{
                        //   click: getFunction(e),
                        //   mouseenter: (s) => {
                        //     showTooltip(e);
                        //   },
                        //   mouseleave: () => {
                        //     hideTooltip(e);
                        //   },
                        // }}
                      />

                      {/* Icono interior */}
                      <a-entity
                        geometry="primitive: circle; radius: 1.5"
                        material="color: #E94E1B; transparent: true; shader: flat; src: #gafas; side: double"
                        position="0 0 0"
                        // position={`0 0 ${
                        //   e.position.x < 0 && e.position.z > 0
                        //     ? -0.02
                        //     :  e.position.x > 0 && e.position.z < 0
                        //     ? -0.02
                        //     : e.position.x > 0 && e.position.z > 0? -0.02:
                        //     0.02
                        // }`}
                        // rotation={`${e.rotation.x} ${
                        //   e.position.x < 0 && e.position.z > 0
                        //     ? e.rotation.y + 180
                        //     :  e.position.x > 0 && e.position.z < 0
                        //     ? e.rotation.y + 360
                        //     : e.position.x > 0 && e.position.z > 0? e.rotation.y + 180:
                        //     e.rotation.y
                        // } ${e.rotation.z}`}
                        animation__pulse="property: scale; from: 0.6 0.6 0.6; to: 0.9 0.9 0.9; dir: alternate; dur: 500; easing: easeInOutQuad; loop: true"
                        {...(e.tipo === 2
                          ? { [`to-scene-${position}`]: true }
                          : {})}
                        // events={{
                        //   click: getFunction(e),
                        //   mouseenter: (s) => {
                        //     showTooltip(e);
                        //   },
                        //   mouseleave: () => {
                        //     hideTooltip(e);
                        //   },
                        // }}
                      />
                    </>
                  )}
                  {/* {isVRMode &&
                    e.tipo === 0 && (
                       <a-video position="0 6 1" scale="6 6 6" autoPlay loop="true" src="https://designer.inmersial.com.ar/sounds/alt/principal-pop1.mp4"></a-video>                      
                    )} */}
                  {isVRMode &&
                    e.tipo === 1 &&
                    (e.titulo === "derecha" || e.titulo === "izquierda") && (
                      <a-entity
                        custom-tooltip={`
                             value: ${e.texto || ""};
                             color: white;
                             backgroundColor: #000000;
                             backgroundOpacity: 0.5;
                             padding: 0.2
                           `}
                        position="0 6 0"
                        scale="6 6 6"
                      />
                      // <a-entity position="0 6 0">
                      //   <a-text
                      //     value={e.texto || ""}
                      //     scale="9 9 9"
                      //     align="center"
                      //     color="white"
                      //     visible={true}
                      //     shader="msdf"
                      //     font="/fonts/custom-font-msdf/customFontAframe-msdf.json"
                      //     font-image="/fonts/custom-font-msdf/customFontAframe.png"
                      //     negate="false"
                      //     baseline="top"
                      //     //id={`text-${e.id}`}
                      //   />
                      //   <a-plane
                      //     material="color: #000000; opacity: 0.5; transparent: true"
                      //     // width="4"
                      //     // height="1"
                      //     position="0 0 0.1"
                      //     rotation="0 180 0"
                      //   >
                      //     <a-text
                      //       value={e.texto || ""}
                      //       rotation="0 180 0"
                      //       scale="9 9 9"
                      //       align="center"
                      //       color="white"
                      //       visible={true}
                      //       shader="msdf"
                      //       font="/fonts/custom-font-msdf/customFontAframe-msdf.json"
                      //       font-image="/fonts/custom-font-msdf/customFontAframe.png"
                      //       negate="false"
                      //       baseline="top"
                      //       //id={`text-${e.id}`}
                      //     />
                      //   </a-plane>
                      // </a-entity>
                    )}
                  {isVRMode && e.tipo === 2 && (
                    <a-entity
                      position={`0 
                                        ${
                                          formatTextWithLineBreaks(
                                            e.nombre || "",
                                            15
                                          ).lines > 1
                                            ? formatTextWithLineBreaks(
                                                e.nombre || "",
                                                15
                                              ).lines + 1
                                            : 2 || 2
                                        }
                                         0`}
                    >
                      <a-text
                        //value={e.nombre || ""}
                        value={
                          formatTextWithLineBreaks(e.nombre || "", 15).text
                        }
                        scale="3 3 3"
                        align="center"
                        color="#E94E1B"
                        visible={true}
                        shader="msdf"
                        font="/fonts/custom-font-msdf/customFontAframe-msdf.json"
                        font-image="/fonts/custom-font-msdf/customFontAframe.png"
                        negate="false"
                        baseline="top"
                        //wrapCount="15"
                        //width="8"
                        //id={`text-${e.id}`}
                      />
                      <a-text
                        //value={e.nombre || ""}
                        value={
                          formatTextWithLineBreaks(e.nombre || "", 15).text
                        }
                        rotation="0 180 0"
                        scale="3 3 3"
                        align="center"
                        color="#E94E1B"
                        visible={true}
                        shader="msdf"
                        font="/fonts/custom-font-msdf/customFontAframe-msdf.json"
                        font-image="/fonts/custom-font-msdf/customFontAframe.png"
                        negate="false"
                        baseline="top"
                        //wrapCount="15"
                        //width="8"
                        //id={`text-${e.id}`}
                      />
                    </a-entity>
                  )}
                </Entity>
                // </a-entity>
              );
            })
          : ""}
        {proyecto &&
          proyecto.otras360 &&
          proyecto.otras360.length > 0 &&
          isVRMode &&
          proyecto.otras360.map((element, index) => {
            const newPosicionX = positionX + index * 2;

            return (
              <Otra360VR
                key={index}
                dataOtra={element}
                Xpos={newPosicionX}
                fondo="#escena0"
                modo={modo}
                onClick={() => {
                  //capturemos la metrica
                  setInteractions((prevInteractions) => ({
                    ...prevInteractions,
                    experience_navigation_button:
                      prevInteractions.experience_navigation_button + 1,
                  }));
                }}
              />
            );
          })}

        {/* boton de exit */}
        {/* {
          isVRMode && (
            <a-entity position="0 -8 15">        
          <a-image
            //  position="0 -8 15"
             class="interactable"
            src={exitPng}
            animation="property: rotation; dur:3000; to: 0 360 0; easing:linear; loop:true"                      
            scale="2 2 2"
            color="#E94E1B"
            onClick={() => {              
              setShowModalVR(true)
            }}
            
          ></a-image>                
        </a-entity>
          )
        } */}
        {/* modalVR de confirmacion de Exit */}
        {/* {
          isVRMode && showModalVR && (
            <ModalConfirmationVR isVisible={showModalVR} onConfirm={onConfirmExitVR} onCancel={onCancelExitVR} position="0 1 3" message="Salir de Modo VR?"/>
          )
        } */}
        {/* <a-entity
          //position="-20 0 -1"
          position="20 0 -1"
          class="interactable objeto"
          //tour-automatico={proyecto}
          scale="2 2 2"
          animation="property: rotation; dur: 3000; to: 0 360 0; easing: linear; loop: true"
          geometry="primitive: sphere; segmentsWidth: 32; segmentsHeight: 16; radius: 0.8"
          material="color: #B0B0B0; metalness: 0.8; roughness: 0.2"
          // onClick= {() => navigationAction(proyecto, escenaIndex, setEscenaIndex)}
          onClick={handleAutoTour(proyecto, escenaIndex, setEscenaIndex)}
         
        ></a-entity>  */}

        {isVRMode && showVideoVR && (
          <>
            <a-video
              position="0 0 -6"
              scale="1 1 1"
              src="#video-1"
              autoplay="true"
              loop="true"
              muted="true" // Importante para autoplay
              width="8"
              height="4.5"
            >
              <a-image
                position="0 -3 0"
                class="interactable"
                src="#closeVideo"
                animation="property: rotation; dur:3000; to: 0 360 0; easing:linear; loop:true"
                scale="1 1 1"
                color="#E94E1B"
                onClick={() => {
                  const videoAsset = document.querySelector("#video-1");
                  if (videoAsset) {
                    videoAsset.pause(); // Parar el video
                    videoAsset.currentTime = 0; // Opcional: volver al inicio
                  }
                  setShowVideoVR(false);
                  setPlaying(false);
                }}
              ></a-image>
              {/* <a-image
            id="videoControls"
            src="#play"
            position="0 -3 0"
            scale="0.5 0.5 1"
            play-pause
          ></a-image> */}
            </a-video>

            {/* <a-plane
              material="src: #video-1"
              position={mobilePlayerPos}
              
              width="4"
              height="2.25"
            ></a-plane> */}
          </>
        )}
      </a-scene>
      {/* {
        automaticTour && (
          <button
        onClick={()=> setAutomaticTour(false)}
        className=""
        style={{
          position: "absolute",
          top: "50%",
          left: "40%",
          padding: 20,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          color: "white",
          border: "solid 1px white",
          fontWeight: "bold",
          fontSize: 20,
          wordWrap: "break-word",
          //width: 500,
        }}
      >
        {`Se encuentra en modo tour automático
        Click para detener`}
      </button>
        )
      } */}
      {/* <button
        onClick={()=> {
          setAutomaticTour(prev => {
            navigationAction(proyecto, escenaIndex, setEscenaIndex);
            return true;
          });
          
        }}
        className=""
        style={{
          position: "absolute",
          top: "10%",          
          padding: 20,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          color: "white",
          border: "solid 1px white",
          fontWeight: "bold",
          fontSize: 20,
          wordWrap: "break-word",
          //width: 500,
        }}
      >
        LANZAR TOUR AUTOMATICO
      </button> */}
      {showAlertLink && (
        <Alert
          id="alertLink"
          message={alertErrorMessage.titulo}
          description={alertErrorMessage.mensaje}
          type="error"
          style={{ opacity: 0.4 }}
        />
      )}
      {/* arranca en " " mientras carga: sin el modificador se veía una pastilla vacía */}
      <h1 className={"titleExperiencia first-step" + (titulo360Value?.trim() ? "" : " titleExperiencia--vacio")}>{titulo360Value}</h1>
      {/* los toques sobre los controles no cuentan como toque al fondo (que muestra/oculta las herramientas) */}
      <div
        className={asistenteEnCharla ? "p360-en-charla" : ""}
        onTouchEnd={(e) => e.stopPropagation()}
      >
        <MenuOtras handleLinkButton={handleClickLinkButton} />
        <VisitasComponent
          cantidad={countVisits}
          setIsSoundPlaying={setIsSoundPlaying}
          isSoundPlaying={isSoundPlaying}
        />
        <div className="p360-col p360-col--izq">
          <MenuEscenas
            handleClickScenesButton={handleClickScenesButton}
            abierto={showCarrousel}
          />
          <MenuRedes handleLinkButton={handleShareButton} />
        </div>
        <div className="p360-col p360-col--der">
          <button
            type="button"
            onClick={actionEnterVR}
            className="p360-btn p360-vidrio third-step"
            title="Ver en VR"
            aria-label="Ver en realidad virtual"
          >
            <IcVR />
          </button>
          <button
            type="button"
            onClick={() => setDesplegarMenu((prev) => !prev)}
            className="p360-btn p360-vidrio p360-btn-herramientas"
            title={desplegarMenu ? "Ocultar herramientas" : "Herramientas"}
            aria-label="Herramientas de la vista"
            aria-pressed={desplegarMenu}
            aria-controls="menuFlotante"
          >
            <IcHerramientas />
          </button>
          <MenuComponent
            handleClickPlusButton={handleClickPlusButton}
            handleClickMinusButton={handleClickMinusButton}
            handleClickFullScreenButton={handleClickFullScreenButton}
            desplegarMenu={desplegarMenu}
          />
        </div>
      </div>
      {elevenLabsAgentId && !proyecto?.asistente?.habilitado && (
        <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 10000 }}>
          <ElevenLabsButton
            onClick={handleElevenLabsToggle}
            status={elevenLabsStatus}
          />
        </div>
      )}
      <AsistenteInmersial
        proyecto={proyecto}
        escenaIndex={escenaIndex}
        onNavegarEscena={(titulo) => setEscena(titulo, proyecto)}
        isSoundPlaying={isSoundPlaying}
        onToggleSonido={(siguiente) => {
          setIsSoundPlaying(siguiente);
          setTimeout(() => {
            const soundEntity = document.getElementById("sound-entity");
            if (!soundEntity || !soundEntity.components || !soundEntity.components.sound) return;
            try {
              if (siguiente) soundEntity.components.sound.playSound();
              else soundEntity.components.sound.pauseSound();
            } catch (error) {
              console.error("Error handling sound:", error);
            }
          }, 1000);
        }}
        camaraRef={camara}
        experienciaId={location.proyectId || (proyecto && proyecto.id)}
      />
      <div
        ref={menuEnlacesOtrasRef}
        onTouchEnd={(e) => e.stopPropagation()}
        onClick={() => {
          //capturemos la metrica
          setInteractions((prevInteractions) => ({
            ...prevInteractions,
            experience_navigation_button:
              prevInteractions.experience_navigation_button + 1,
          }));
        }}
      >
        <MenuEnlaces
          handleLinkButton={handleNavigateRelated}
          data={linksDataState}
          handleShowFromPadre={handleCardRelacionadas}
          desplegarCard={desplegarCard}
          enCharla={asistenteEnCharla}
        />
      </div>
      <ModalShare
        showModal={showModalShare}
        setShowModal={setShowModalShare}
        titulo={proyecto?.nombre}
        url={window.location.href}
      />
    </>
  );
}
